<template>
  <div class="grid-view queryInvoice">
    <div class="main-content">
      <!--    <template v-slot:searchAreaHeader>-->

      <!--    </template>-->
      <!--  todo: config-module  -->
      <search-item
        v-if="isShow"
        key="tabInvoiceQuery_searchItem"
        ref="searchItem"
        :show-more-scheme="true"
        :show-simple="true"
        :is-append-query="true"
        :expand-adv="true"
        :search-item-code="$t('Clearing.InvoiceInquiry')"
        config-module="502"
        grid-config-module="190605"
        :custom-sim-query-placeholder="$t('Clearing.QuickSearchInvoiceNumber')"
        :auto-init="true"
        :custom-search-items="customSearchItems"
        @advSearchItemCallBack="fetchData"
        @simSearchItemCallBack="fetchDataBykeyWord"
        @advToggle="scrollCallback"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
      >
        <div slot="operations" style="display: flex;">
          <el-button type="primary" no="1" @click="showInvoiceHandler(undefined, true)">{{ $t('Invoice.invoice_view') }}</el-button>
          <el-button v-permission="['button_ACInvoice_approve']" type="primary" no="2" @click="approveHandler">{{ $t('Invoice.invoice_recheck') }}</el-button>
          <el-button v-permission="['button_ACInvoice_approve']" type="primary" no="3" @click="unapproveHandler">{{ $t('Invoice.invoice_cancelRecheck') }}</el-button>
          <!--  todo: 无实际弹窗页,直接调用后端 按需参考复核&取消复核添加确认对话框 -->
          <el-button v-permission="['button_ACInvoice_forceDelete']" type="danger" no="4" @click="forceDeleteHandler">{{ $t('Invoice.invoice_forceDelete') }}</el-button>
          <el-button type="danger" no="5" @click="deleteHandler">{{ $t('Invoice.invoice_delete') }}</el-button>
          <el-button v-permission="['button_ACInvoice_invalid']" no="6" type="danger" @click="revokeHandler">{{ $t('Invoice.invoice_invalid') }}</el-button>
          <el-button v-show="(properties.enableCustomizeRevokeInvoice && $checkPermission(['button_ACInvoice_redPunch'])) || jinRongExchangeMode" no="7" type="danger" @click="redPunchHandler">{{ $t('Invoice.invoice_redPunch') }}</el-button>
          <!--          <el-button v-show="isNuoNuo && $checkPermission(['button_ACInvoice_redPunch'])" no="ApplyRed" type="danger" @click="redApplyHandler">{{ $t('Invoice.ApplyRed') }}</el-button>-->
          <!--          <el-button v-show="isFei" type="danger" @click="rollBackRedPunchHandler">{{ $t('Invoice.CancelApplyRed') }}</el-button>-->
          <!--          <el-button type="primary" no="9" @click="exportAVTHandler">{{ $t('Invoice.invoice_exportVATInvoice') }}</el-button>-->
          <!-- 发票号导入 -->
          <!--          <cargo-el-upload
            no="importVATHandler"
            action
            accept=".xlsx"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="importVATHandler"
            style="padding-left: 5px; padding-right: 5px;"
          >
            <el-button type="primary" no="InvoiceNoImport">{{ $t('Invoice.InvoiceNoImport') }}</el-button>
          </cargo-el-upload>-->

          <el-button v-permission="['button_ACInvoice_exportInvoiceData']" type="primary" no="9" @click="exportInvoiceDataHandler">{{ $t('CargoMsg.Cargo_InvoiceExport') }}</el-button>
          <!-- 发票号导入 -->
          <cargo-el-upload
            v-permission="['button_ACInvoice_importInvoiceNo']"
            no="importVATHandler"
            action
            accept=".xlsx, .xls"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="importInvoiceDataHandler"
            style="padding-left: 5px; padding-right: 5px;"
          >
            <el-button type="primary" no="InvoiceNoImport">{{ $t('CargoMsg.Cargo_InvoiceNoImport') }}</el-button>
          </cargo-el-upload>
          <el-button v-if="false" no="10" type="primary">{{ $t('Invoice.invoice_importVATInvoice') }}</el-button>
          <el-button v-permission="['button_fmMakeInvoice_CATISExport']" no="11" type="primary" @click="interfaceExportBatchHandler">{{ $t('Invoice.invoice_CATISExport') }}</el-button>
          <el-button type="primary" no="12" @click="printHandler">{{ $t('Invoice.invoice_print') }}</el-button>
          <el-button type="primary" no="13" @click="toApplyPay">{{ $t('Invoice.invoice_applyForPayment') }}</el-button>
          <el-button type="primary" no="14" @click="batchDownloadElectronicInvoice">{{ $t('Invoice.invoice_BatchDownloadElectronicInvoice') }}</el-button>
          <el-button v-show="properties.interfaceNameEI === InvoiceConstant.INVOICE_YSHS && properties.interfaceName === InvoiceConstant.INVOICE_YSHS && $checkPermission(['button_ACInvoice_getInvoiceNo'])" no="15" type="primary" @click="getInvoiceInfo">{{ $t('Invoice.GetInvoiceNumber') }}</el-button>
          <el-button v-if="$checkPermission(['button_ACInvoice_updateInvoiceType'])" no="16" type="primary" @click="updateInvoiceHandler">{{ $t('Invoice.invoice_UpdateInvoice') }}</el-button>
          <el-button v-show="isBwjsy && !isNuoNuo && $checkPermission(['button_ACInvoice_getInvoiceNo'])" no="17" type="primary" @click="getInvoiceNoByBwjsy">{{ $t('Invoice.GetInvoiceNumber') }}</el-button>
          <el-button v-show="isBwjsy && !isNuoNuo" type="primary" @click="personAuth">{{ $t('Invoice.PersonAuth') }}</el-button>
          <el-button v-show="isHtxx && !isNuoNuo && $checkPermission(['button_ACInvoice_getInvoiceNo'])" no="18" type="primary" @click="getInvoiceNoByHtxx">{{ $t('Invoice.GetInvoiceNumber') }}</el-button>
          <el-button v-show="(isTaxEasyThreePlus || isNuoNuo || isAisinoEi) && $checkPermission(['button_ACInvoice_getInvoiceNo'])" no="getInvoiceNoQd" type="primary" @click="getInvoiceNoQd">{{ $t('Invoice.GetInvoiceNumber') }}</el-button>
          <el-button v-show="showEasyPaperTicketPrint" type="success" no="19" @click="taxEasyThreePaperPrint">{{ $t('Invoice.PaperTicketPrinting') }}</el-button>
          <el-button v-show="searchConditions.paymentType === 1 && properties.settlementCenterMode" type="primary" no="20" @click="sendSharingCenter">{{ $t('CargoMsg.Cargo_SendingSharingCenter') }}</el-button>
          <el-button v-show="searchConditions.paymentType === 1 && properties.settlementCenterMode" type="primary" no="21" @click="querySendResult">{{ $t('CargoMsg.Cargo_GetSendResult') }}</el-button>
          <el-button v-show="properties.isEasyInoivceVietnam && $checkPermission(['button_ACInvoice_getInvoiceNo'])" no="22" type="primary" @click="getInvoiceNoByEasyInvoice">{{ $t('Invoice.GetInvoiceNumberVietnam') }}</el-button>
          <el-button v-show="properties.isEasyInoivceVietnam && $checkPermission(['button_ACInvoice_getInvoiceNo'])" no="23" type="primary" @click="getInvoiceNoByEasyInvoice('checkInvoiceState')">{{ $t('Invoice.GetInvoiceStateVietnam') }}</el-button>
          <el-button v-show="properties.isEasyInoivceVietnam && $checkPermission(['button_ACInvoice_getInvoiceNo'])" no="24" type="primary" @click="getInvoiceNoByEasyInvoice('getInvoicePdf')">{{ $t('Invoice.GetInvoicePdfVietnam') }}</el-button>
          <el-button v-if="(hmToFinanceApi || jydToFinanceApi || qlToFinanceApi) && $checkPermission(['button_ACInvoice_syncCloud'])" type="primary" no="25" @click="syncCloudPlatform">{{ $t('CargoMsg.Cargo_SynchronousCloudPlatform') }}</el-button>
          <!--导出Accpac发票数据-->
          <el-button v-show="toExoSystemTp && $checkPermission(['button_ACInvoice_exportPillInvoice'])" no="exportPillInvoice" type="primary" @click="exportPillInvoiceHandler">{{ $t('PillReport.ExportInvoiceData') }}</el-button>
          <!--预览凭证-->
          <el-button v-show="$checkPermission(['button_ACInvoice_previewVoucher'])" no="previewVoucher" type="primary" @click="previewVoucherHandler">{{ $t('CargoMsg.Cargo_PreviewVoucher') }}</el-button>
          <!--导出凭证-->
          <el-button v-show="$checkPermission(['button_ACInvoice_exportVoucher'])" no="exportVoucher" type="primary" @click="exportVoucherHandler">{{ $t('CargoMsg.Cargo_ExportVoucher') }}</el-button>
          <template v-for="(item, index) in instructioinBtns">
            <el-button
              :key="'instruction' + index"
              type="primary"
              :disabled="!item.allowOperate"
              @click="onInstructionClick(item)"
            >
              {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
            </el-button>
          </template>
        </div>
        <template slot="searchAreaHeader">
          <div class="app-main-inner-row extension-conditions-form">
            <el-form :inline="true" label-position="left">
              <el-form-item :label="$t('Invoice.invoice_revenueAndExpenditureMethod')" class="el-form-item-search">
                <el-radio-group v-model="searchConditions.paymentType" no="20">
                  <el-radio v-if="$checkPermission(['button_tabQueryInvoice_allCharge'])" :label="-1">{{ $t('Invoice.invoice_all') }}</el-radio>
                  <el-radio v-if="$checkPermission(['button_tabQueryInvoice_arCharge'])" :label="1">{{ $t('Invoice.invoice_receivables') }}</el-radio>
                  <el-radio v-if="$checkPermission(['button_tabQueryInvoice_apCharge'])" :label="0">{{ $t('Invoice.invoice_payables') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-show="useOrderCenterMode" label-width="0" class="el-form-item-search">
                <el-checkbox v-model="searchConditions.internalCharge" no="21">{{ $t('CargoMsg.Cargo_InternalCharges') }}</el-checkbox>
              </el-form-item>
              <el-form-item :label="$t('Invoice.invoice_invoiceDate')" class="el-form-item-search">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-date-picker
                        v-model="searchConditions.inputDateStart"
                        no="22"
                        type="date"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        :editable="false"
                      /></el-form-item>
                  </el-col>
                  <el-col :span="2"><span>{{ $t('Invoice.invoice_dateTo') }}</span></el-col>
                  <el-col :span="8">
                    <el-form-item label-width="0">
                      <el-date-picker
                        v-model="searchConditions.inputDateEnd"
                        no="23"
                        type="date"
                        clearable
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label-width="0">
                      <el-checkbox v-model="allowTwoYearOutside" no="24">{{ $t('Invoice.invoice_queryLotsOfData') }}</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>
        </template>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid-wrapper
          config-module="190605"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :sum-column-defs="sumColumnDefs"
          :row-data="rowData"
          :customs-column-defs="customsColumnDefs"
          :show-row-groups="dataListDragGroup"
        />
      </div>
      <div id="footer-wrapper" class="pagination-wrapper">
        <div :class="[shouldFixed?'fixedBottom':'']" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
          <charge-count-group
            v-if="reCalc"
            :selected-count="totalAmountToCurrency.selectedCount"
            :data-provider="totalAmountToCurrency.dataProvider"
            :display-and-count-field-list="totalAmountToCurrency.displayAndCountFieldList"
            :basic-currency="localCurrency"
            :always-show="true"
            :charge-total-data="totalAmountToCurrency.chargeTotalData"
            source="invoiceQueryList"
          />
        </div>
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="searchConditions.total"
            layout="total"
          />
        </div>
        <cargo-pagination
          v-if="!appendQuery"
          config-module="190605"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchDataByPage"
        />
      </div>
    </div>
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
    <!-- 开票弹窗 -->
    <invoice-detail-dialog
      ref="makeInvoiceDialog"
      :visible.sync="this.step === 'step3'"
      :title="$t('Invoice.invoice_invoiceInformation')"
      :params="makeInvoiceDialog.params"
      :properties="this.properties"
      :location="location"
      view-source="tabInvoiceQuery"
      @toStepHandler="toStepHandler"
      @pageChange="pageChange"
      @saveSuccess="saveSuccess"
      @refresh="toQueryInvoiceList"
    />
    <!--申请付款-->
    <bill-payment-dialog
      ref="billPayment"
      :location="location"
      :visible.sync="showBillPaymentDialog"
      @cancel="cancelBillPayment"
    />
    <!-- 邮件发送日志 -->
    <email-log-title-window
      v-if="emailLogTitleWindow.visible"
      ref="emailLogTitleWindow"
      :visible.sync="emailLogTitleWindow.visible"
      :invoice-key="emailLogTitleWindow.invoiceKey || ''"
    />
    <!-- 下载日志弹窗 -->
    <download-log-window
      v-if="downloadLogWindow.visible"
      ref="downloadLogWindow"
      :visible.sync="downloadLogWindow.visible"
      :fk-uuid="downloadLogWindow.invoiceKey || ''"
    />
    <!-- 发送邮件 -->
    <email-enter-title-window
      v-if="emailEnterTitleWindow.visible"
      ref="emailEnterTitleWindow"
      :visible.sync="emailEnterTitleWindow.visible"
      :invoice-key="emailEnterTitleWindow.invoiceKey"
      :account-id="emailEnterTitleWindow.accountId"
      @sendEmailSuccess="sendEmailSuccessHandler"
    />
    <!--    更新发票-->
    <update-invoice-window
      v-if="updateInvoice.visible"
      :visible.sync="updateInvoice.visible"
      :invoice-list="updateInvoice.invoiceList"
      :fei="isFei"
      @updateSuccess="updateSuccessHandler"
    />
    <!-- 容津3.0纸票打印弹窗 -->
    <cargo-dialog
      :title="$t('Invoice.PaperTicketPrinting')"
      :visible="taxEasyThreePrintDialog.visible"
      :can-maximize="true"
      @close="taxEasyThreePrintDialog.visible=false"
    >
      <iframe :src="taxEasyThreePrintDialog.url" style="width: 100%;height: 100%;min-height: 600px;border: none;" />
    </cargo-dialog>
    <!-- 批量红冲弹框-全电 -->
    <el-dialog
      v-if="customizeRevokeInvoiceAutoCharge === 2 && batchRedFlush.visible"
      v-el-drag-dialog
      :visible.sync="batchRedFlush.visible"
      :title="$t('Clearing.RedPunchInvoice')"
      width="410px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column;">
        <el-form label-width="120px" label-position="left">
          <el-form-item label-width="0">
            <div class="el-message-box__status el-icon-warning" style="font-size: 20px !important;" />
            <div class="el-message-box__message">
              {{ $t('Invoice.BatchCheckRedFlushInvoiceTipOne') }}
              <span style="font-weight: bold; color: red; font-size: 18px;">{{ batchRedFlush.invoiceKeys.length }}</span>
              {{ $t('Invoice.BatchCheckRedFlushInvoiceTipTwo') }}
            </div>
          </el-form-item>
          <el-form-item :label="$t('Invoice.SelectReasonForRedOffsetInvoice')">
            <el-select v-model="batchRedFlush.redOffsetReason" :clearable="false" style="width: 250px">
              <el-option :label="$t('Invoice.IncorrectInvoicing')" :value="'01'" />
              <el-option :label="$t('Invoice.ServiceTermination')" :value="'03'" />
              <el-option :label="$t('Invoice.SalesAllowance')" :value="'04'" />
              <el-option v-if="showSalesReturn" :label="$t('Invoice.SalesReturn')" :value="'02'" />
            </el-select>
          </el-form-item>
          <div style="line-height: 24px;">
            <i class="el-icon-question" style="font-size: 18px;color: black;" />
            <br>
            <span>{{ $t('Clearing.BatchCheckRedFlushInvoiceMessageOne') }}</span>
            <br>
            <span v-if="properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS">{{ $t('Clearing.BatchCheckRedFlushInvoiceMessageTwo') }}</span>
            <span v-else>{{ $t('Clearing.BatchCheckRedFlushInvoiceMessageThree') }}</span>
          </div>
        </el-form>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="confirm" type="primary" @click="confirmRedPunch()">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="cancel" @click="batchRedFlush.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="customizeRevokeInvoiceAutoCharge !== 2 && batchRedFlush.visible"
      v-el-drag-dialog
      :visible.sync="batchRedFlush.visible"
      :title="$t('Message.Prompt')"
      width="550px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column;">
        <el-form label-width="75px" label-position="right">
          <el-form-item label-width="0">
            <div class="el-message-box__status el-icon-warning" />
            <div class="el-message-box__message">
              {{ this.$t('Invoice.BatchCheckRedFlushInvoiceTipOne', ) }}
              <span style="font-weight: bold; color: red; font-size: 18px;">{{ batchRedFlush.invoiceKeys.length }}</span>
              {{ this.$t('Invoice.BatchCheckRedFlushInvoiceTipTwo', ) + batchRedFlush.message }}
            </div>
          </el-form-item>
          <el-form-item :label="$t('Invoice.RedFlushReason')" required>
            <el-radio-group v-model="batchRedFlush.redOffsetReason">
              <el-radio :label="'01'">{{ $t('Invoice.IncorrectInvoicing') }}</el-radio>
              <el-radio :label="'02'">{{ $t('Invoice.SalesReturn') }}</el-radio>
              <el-radio :label="'03'">{{ $t('Invoice.ServiceTermination') }}</el-radio>
              <el-radio :label="'04'">{{ $t('Invoice.SalesAllowance') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="confirm" type="primary" @click="confirmRedPunch()">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="cancel" @click="batchRedFlush.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量红冲弹框 -->
    <el-dialog
      v-if="batchRedPunchDialog.visible"
      v-el-drag-dialog
      :visible.sync="batchRedPunchDialog.visible"
      :title="$t('Clearing.RedPunchInvoice')"
      width="410px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column;">
        <el-form label-width="120px" label-position="left">
          <el-form-item label-width="0">
            <div class="el-message-box__status el-icon-warning" style="font-size: 20px !important;" />
            <div class="el-message-box__message">
              {{ $t('Invoice.BatchCheckRedFlushInvoiceTipOne') }}
              <span style="font-weight: bold; color: red; font-size: 18px;">{{ batchRedPunchDialog.invoiceKeys.length }}</span>
              {{ $t('Invoice.BatchCheckRedFlushInvoiceTipTwo') }}
            </div>
          </el-form-item>
          <el-form-item :label="$t('Invoice.SelectReasonForRedOffsetInvoice')">
            <el-select v-model="batchRedPunchDialog.redOffsetReason" :clearable="false" style="width: 250px">
              <el-option :label="$t('Clearing.IncorrectInvoiceInformation')" :value="'InvoiceError'" />
              <el-option :label="$t('Clearing.IncorrectChargeInformation')" :value="'ChargeError'" />
            </el-select>
          </el-form-item>
          <div style="line-height: 24px;">
            <i class="el-icon-question" style="font-size: 18px;color: black;" />
            <br>
            <span>{{ $t('Clearing.BatchCheckRedPunchInvoiceMessageOne') }}</span>
            <br>
            <span>{{ $t('Clearing.BatchCheckRedPunchInvoiceMessageTwo') }}</span>
          </div>
        </el-form>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="confirm" type="primary" @click="doRedPunchInvoices()">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="cancel" @click="batchRedPunchDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 二维码弹框 -->
    <el-dialog
      v-if="ewmDialog.visible"
      v-el-drag-dialog
      :visible.sync="ewmDialog.visible"
      :title="$t('Message.Prompt')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column;">
        <el-form label-width="75px" label-position="right">
          <el-form-item label-width="0">
            <div class="el-message-box__status el-icon-warning" />
            <div class="el-message-box__message">
              {{ this.$t('Invoice.WeChatScanningAgain') }}
            </div>
          </el-form-item>
          <div style="margin: 0 auto;width: fit-content;">
            <qr class="vue-qr" :text="ewmDialog.ewm" :logo-scale="200" :size="200" />
          </div>
        </el-form>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="Certified" type="primary" :disabled="!!ewmDialog.time" @click="realPersonAuthentication(true)">{{ ewmDialog.time ? ($t('Invoice.Certified') + '(' + ewmDialog.time + ')') : $t('Invoice.Certified') }}</el-button>
      </div>
    </el-dialog>
    <!--    共享中心推送日志-->
    <push-log-dialog
      v-if="pushLogDialog.visible && !qlToFinanceApi"
      :visible.sync="pushLogDialog.visible"
      :uuid="pushLogDialog.uuid"
    />

    <push-log-dialog-ql
      v-if="pushLogDialog.visible && qlToFinanceApi"
      :visible.sync="pushLogDialog.visible"
      :uuid="pushLogDialog.uuid"
    />

    <!-- 开票申请审批流 实质是：invoice-detail-dialog -->
    <invoice-work-flow-apply-dialog
      v-if="workFlowApplyDialog.visible"
      ref="workFlowApplyDialog"
      :is-bpm="true"
      :process-info="workFlowApplyDialog.documentProcess"
      :records="workFlowApplyDialog.approvalCommentsRecords"
      type="approve"
      :visible.sync="workFlowApplyDialog.visible"
      :title="$t('Invoice.invoice_invoiceInformation')"
      :properties="workFlowApplyDialog.invoiceProperties"
      view-source="tabInvoiceQuery"
      @pageChange="pageChange"
      @close="workFlowApplyDialog.visible=false"
      @closeAndRefresh="()=> {
        workFlowApplyDialog.visible=false
        fetchDataByPage()
      }"
    />
    <accounting-entry-window
      v-if="accountingEntryWindow.visible"
      :visible="accountingEntryWindow.visible"
      :is-ext="accountingEntryWindow.isExt"
      :prefix-data-provider="accountingEntryWindow.prefixDataProvider"
      :account-title-data-provider="accountingEntryWindow.accountTitleDataProvider"
      :mapping-departments="accountingEntryWindow.mappingDepartments"
      :mapping-staffs="accountingEntryWindow.mappingStaffs"
      :voucher="accountingEntryWindow.rowData"
      :index="accountingEntryWindow.index"
      :account-set="accountingEntryWindow.accountSet"
      :check="false"
      :check-department="false"
      :preview="true"
      @close="() => accountingEntryWindow.visible=false"
      @updateAudit="toQueryInvoiceList()"
    />
    <!-- 合并发票文件(用于指令处理) -->
    <merge-invoice-file-window ref="mergeInvoiceFileWindow" />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { DocumentManage, submitDataByPost, stringToBool, sleep, ensureExecuteSuccess } from '@/utils/commonUtil'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { getGridSelected, recordSelectedStatus } from '@/utils/agGrid'
import BillPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentDialog'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { formatNumberToThousands } from '@/utils'
import lodash from 'lodash'
import {
  approveInvoices,
  checkToVoucher,
  checkExportedToVoucher,
  deleteInvoices,
  getInvoiceDetails,
  getInvoiceNos,
  outInterfaceExportBatch,
  outInterfaceExportBatchEi,
  queryInvoiceList,
  redPunchInvoices,
  revokeInvoices,
  getInvoiceNoByBwjsy,
  getInvoiceNoByHtxx,
  getInvoiceNoByEasyInvoice,
  getInvoicePdfByEasyInvoice,
  getInvoiceStatusByEasyInvoice,
  checkInvoiceExistfFile,
  exportInvoiceQd,
  importInvoiceQd,
  redPunchInvoicesQd,
  searchRedResult,
  redPunchApplyRollbackOrSearch,
  authRecognition,
  getInvoiceNoQd,
  redApply,
  exportInvoiceDataFunc,
  importInvoiceDataFunc,
  doHmSyncInvoiceChargeToYongYou,
  doSyncInvoiceQL,
  syncInvoiceToYYU8,
  checkInvoiceToYYU8,
  exportInvoiceDataOJFunc,
  importInvoiceDataOJFunc,
  queryLtsInvoiceFunc,
  getTaxEasyThreePaperPrintUrl,
  addDownloadLog
} from '@/api/clearing/invoice'
import invoiceDetailDialog from './invoiceDetailDialog'
import invoiceWorkFlowApplyDialog from './invoiceDetailDialog'
import emailLogTitleWindow from './emailLogTitleWindow'
import downloadLogWindow from './downloadLogWindow'
import emailEnterTitleWindow from './emailEnterTitleWindow'
import StrUtils from '@/utils/StrUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import DateUtils from '@/utils/dateUtils'
import moment from 'moment'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import { Invoice } from '@/class/model/act/Invoice'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants.js'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import { Once } from '@/utils/commonUtil'
import ChargeCountDataAdapte from '@/components/Cargo/Act/chargeSummary/ChargeCountDataAdapte'
import ChargeCountField from '@/components/Cargo/Act/chargeSummary/ChargeCountField'
import ChargeCountManager from '@/components/Cargo/Act/chargeSummary/ChargeCountManager'
import ChargeGroupCounter from '@/components/Cargo/Act/chargeSummary/ChargeGroupCounter'
import { getToken } from '@/utils/auth'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import URL from '@/api/urlTranslator'
import { getBankAccountList } from '@/api/bankAccount'
import { getInvoiceTitlesByOffice } from '@/api/sysManage/officeInvoiceTitle'
import invoiceQueryCargoGridShowBigContent from '@/views/cargo/v0/Clearing/components/makeInvoice/invoiceQueryCargoGridShowBigContent'
import $store from '@/store'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import UpdateInvoiceWindow from '@/views/cargo/v0/Clearing/components/makeInvoice/updateInvoiceWindow'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { jumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper'
import CargoElUpload from '@/components/Cargo/Common/cargoElUpload'
import qr from 'vue-qr'
import { BPM_STATES_UN_APPROVED, LOG_MAKE_INVOICE } from '@/class/cargo/model/parameters/SystemConstants.js'
import { deleteProcess, existWorkflowGroup } from '@/api/workflow'
import {
  checkPushFunc,
  pushPreliminaryFunc,
  queryOrderLogFunc
} from '@/api/act/preliminaryEstimate'
import pushLogDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/pushLogDialog'
import pushLogDialogQl from '@/views/cargo/v0/Clearing/components/SharedCenter/pushLogDialogQl'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import {
  COLLECT_INVOICE,
  Job_CHARGE,
  MAKE_INVOICE,
  MAKE_INVOICE_BILLING,
  MAKE_INVOICE_INTERNAL_INVOICE
} from '@/class/cargo/model/parameters/WorkflowConstants'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { OPERATOR_IN } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { exportInvoice } from '@/api/clearing/pillReport'
import { BSWarningUtil } from '@/class/cargo/model/utils/BSWarningUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import AccountingEntryWindow from '@/views/cargo/v0/FinanceManage/VoucherMaintenance/AccountingEntryWindow'
import { queryInvoiceAccountingDocument } from '@/api/financeManage/accountingDocument'
import VoucherUtils from '@/utils/VoucherUtils'
import VoucherDatePopover from '@/views/cargo/v0/Clearing/components/makeInvoice/VoucherDatePopover.vue'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { getInstructions } from '@/api/sysManage/uiCustom'
import MergeInvoiceFileWindow from '@/components/Cargo/Job/mergeInvoiceFileWindow'

export default {
  name: 'TabInvoiceQuery',
  components: { qr, CargoElUpload, pushLogDialog, pushLogDialogQl, UpdateInvoiceWindow, searchItem, cargoTemplateSelectorDialog, BillPaymentDialog, invoiceDetailDialog, ChargeCountGroup, emailLogTitleWindow, downloadLogWindow, emailEnterTitleWindow, invoiceQueryCargoGridShowBigContent, CargoDialog, cargoAgGridWrapper, invoiceWorkFlowApplyDialog, AccountingEntryWindow, VoucherDatePopover, MergeInvoiceFileWindow },
  props: {
    isShow: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      InvoiceConstant,
      loading: false,
      documentManage: new DocumentManage(),
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      pushLogDialog: {
        visible: false,
        uuid: ''
      },
      allowTwoYearOutside: false,
      defaultSearchItems: [],
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
        paymentType: -1, // 收付方式，是否应收
        invoiceDateSearch: [], // 开票日期
        inputDateStart: moment().subtract(2, 'y').format('yyyy-MM-DD'),
        inputDateEnd: '',
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        requires: ['writeoff', 'voucherDate', 'job', 'billing', 'billPayment', 'invoiceItem', 'targetVoucherNo', 'invoiceQuery', 'actualAmount'],
        snapshotCondition: {}, // 收付款条件查询
        invoiceNoState: -1, // 发票号状态：-1: 不限制；0: 没有发票号；1: 有发票号
        clearingState: -1, // 核销状态：0:有未销账；1:有已销账
        jobStates: [], // 业务状态
        exceptKeys: [], // 在查询中想要例外的对象列表
        selectedEntitiesForHedging: [], // 排除
        internalCharge: false // 内结
      },
      perConfigName: '',
      gridRefreshId: 0,
      gridParams: {},
      showFba: false, // 显示FBA相关列
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onSelectionChanged: this.toRefreshSelectedCount,
        onRowDoubleClicked: this.showInvoiceHandler,
        frameworkComponents: {
          VoucherDatePopover: VoucherDatePopover
        }
      },
      rowData: [],
      // 右下角合计详情小弹窗
      totalDetailDialog: {
        show: false,
        data: [
          {
            currency: this.$t('Message.Receivable'),
            chinese: '100',
            usd: '100',
            hkd: '99',
            qyd: '50'
          },
          {
            currency: this.$t('Message.Payable'),
            chinese: '100',
            usd: '100',
            hkd: '99',
            qyd: '50'
          },
          {
            currency: this.$t('Clearing.Total'),
            chinese: '0',
            usd: '0',
            hkd: '0',
            qyd: '0'
          }
        ]
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'JOBLIST',
        data: {
          JOB_UUID: [],
          LOB: 'SE'
        }
      },
      showBillPaymentDialog: false, // 付款申请弹窗
      // 开票/收票弹窗页
      makeInvoiceDialog: {
        visible: false,
        params: {}
      },
      step: '', // step1=makeInvoiceStepOneDialog ; step2=makeInvoiceStepTwoDialog ; step3=makeInvoiceDialog
      // 查看发票
      properties: {
        selectedEntities: [], // 已经选中的实体
        invoices: [], // 生成发票列表
        invoice: {}, // 当前发票
        currentPage: 1, // 顺序号
        totalPage: 0, // 发票总数
        enableCustomizeRevokeInvoice: false, // 是否作废红冲发票客户化(亚东)
        interfaceName: '', // 纸质发票税控接口类型
        interfaceNameEI: '', // 电子发票税控接口类型
        terminalSn: '', // 百旺开票终端标识
        storageURL: '', // StorageURL
        showChargeDetailByInvoice: false, // ShowChargeDetailByInvoice：增值发票是否可以显示明细
        invoiceNoEditable: false, // InvoiceSearchEdit: 开票查询修改发票号
        rbgShowChargeDetail: '', // 显示明细
        autoGenerateVoucher: false // 是否开启水单和发票自动生成凭证功能
      },
      invoiceHasAllowedInvalid: false, // 系统已核销或部分核销的费用是否允许删除作废发票
      customizeRevokeInvoiceAutoCharge: 0, // 是否红冲自动生成正数费用，(0=默认否；1=是; 2=新逻辑)
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      jinRongExchangeMode: false, // 锦荣交单模式
      totalAmountToCurrency: { // 右下角合计组件相关参数
        selectedCount: 0,
        dataProvider: [], // 数据源
        chargeTotalData: [], // 后端返回的原币种合计数据
        displayAndCountFieldList: [
          new ChargeCountField(this.$t('CargoMsg.Cargo_OutstandingAmount'),
            'unverifiedAmount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('CargoMsg.Cargo_WriteOffAmountCharge'),
            'verifiedAmount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('CargoMsg.Cargo_ReceivableExcludingTax'),
            'invoiceRTaxExcluded', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('CargoMsg.Cargo_TaxIncludedReceivable'),
            'invoiceRTaxIncluded', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('CargoMsg.Cargo_PayableExcludingTax'),
            'invoicePTaxExcluded', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('CargoMsg.Cargo_TaxPayable'),
            'invoicePTaxIncluded', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('CargoMsg.Cargo_TotalExcludingTax'),
            'totalInvoiceTaxExcluded', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('CargoMsg.Cargo_TotalTaxIncluded'),
            'totalInvoiceTaxIncluded', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_convert_after_tax'),
            'totalInvoiceTaxExcludedRMB', 'currency', null, ChargeCountManager.DISP_IN_GROUP, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_convert'),
            'amount2RMB', 'currency', null, ChargeCountManager.DISP_IN_GROUP, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('CargoMsg.Cargo_TotalAmountTax'),
            'taxAmount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ])
        ]
      },
      once: new Once(this),
      invoiceUuid: '', // 发票UUID，双击查看
      shouldFixed: false,
      emailLogTitleWindow: {
        visible: false,
        invoiceKey: ''
      },
      downloadLogWindow: {
        visible: false,
        invoiceKey: ''
      },
      emailEnterTitleWindow: {
        visible: false,
        invoiceKey: '',
        accountId: 0
      },
      updateInvoice: {
        visible: false,
        invoiceList: []
      },
      queryOfficeId: 0, // 记录查询时的分公司Id
      customSearchItems: [],
      storageURL: '',
      taxEasyThreePrintDialog: {
        visible: false,
        url: ''
      },
      appendQuery: false, // 追加查询
      ewmDialog: { // 二维码弹框
        visible: false,
        ewm: '',
        curTime: null, // 当前倒计时
        time: 15 // 倒计时 15s
      },
      batchRedFlush: { // 批量红冲弹框-全电
        visible: false,
        message: '',
        redOffsetReason: '01',
        invoiceKeys: []
      },
      batchRedPunchDialog: { // 批量红冲弹框
        visible: false,
        redOffsetReason: 'InvoiceError',
        invoiceKeys: []
      },
      location: LOG_MAKE_INVOICE.code,
      workFlowApplyDialog: {
        visible: false,
        invoiceProperties: {
          // mode: 0, // 弹窗模式[default:0] 0-开票模式  1-对冲开票模式
          isHedge: false, // 是否对冲
          isAr: true, // 是否应收

          makeInvoiceMethod: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单
          makeInvoiceMethodHedge: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单

          typeGroup: 'multi', // 开票类型：multi=合并开票、job=按业务开票、single=按记录开票、settlementAgent=按结算代理开票、title=按抬头开票
          invoiceType: 0, // 发票类型：0=普通发票、1=专用发票、2=增值税普通发票、3=增值税专用发票、4=内部发票
          groupingMakeType: 0, // 发票种类：0=纸质发票、1=电子发票

          currencyGroup: 0, // 分币种开票：0=拆分币种开票、1=合并币种
          cbAssignCurrency: true, // 指定发票币种
          groupingCurrencyType: 0, // currencyGroup + cbAssignCurrency: 0=合并币种、1=拆分币种+指定发票币种、2=拆分币种+非指定发票币种
          currency: 'RMB', // 币种

          showChargeDetail: false, // 是否显示费用明细
          useDefaultRate: false, // 按财务汇率开票
          isInvoicingByBillingRate: false, // 按账单汇率
          billingRateMap: {}, // 账单币种、账单汇率
          makeCostInvoice: false, // 生成成本发票
          isGenCostInvoice: false, // 是否生成成本发票: isAr ? makeCostInvoice : false
          costInvoiceProp: {},
          defaultContent: false, // 将本次内容设置为默认开票信息

          invoiceGoodsName: {}, // 发票项目名称
          settleDepartment: 0, // 结算部门
          settleDepartmentPrefix: '', // 结算部门归属工作号

          otherCurrencys: [], // 其它币种
          otherRates: [], // 其它币种汇率
          txtCurrency1: '',
          txtRate1: '',
          txtCurrency2: '',
          txtRate2: '',
          rateCache: {}, // 对比发票币种的汇率
          cbAlwarysUseRate: false, // 一直按该汇率开票

          branchId: this.$store.getters.currentOfficeId, // 分公司 Session.getInstance().getOfficeId()
          inputByDep: this.$store.getters.currentDeptId, // 部门 Session.getInstance().currentDepartment.departmentId

          titleMap: {}, // 获取账单所对应的结算单位: getTitleMap()
          invoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(entities)
          hedgeInvoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(hedgeEntities)

          selectedEntities: [], // 已经选中的实体
          selectedEntitiesHedge: [], // 已经选中的对冲实体
          entities: [], // 开票实体
          hedgeEntities: [], // 对冲实体
          allEntities: [], // 所有实体
          allCharges: [],
          chargeMap: {},
          invoices: [], // 生成发票列表
          invoice: {}, // 当前发票
          currentPage: 1, // 顺序号
          totalPage: 0, // 发票总数
          invoiceGoodsNameList: [], // 发票项目名称列表
          invoiceItemGoodsName: 0, // InvoiceItemGoodsName：开票发票项目默认货物或应税劳务名称
          defaultGoodsName: '', // InvoiceMergeName：合并开票费用名称
          receivedRadio: 'ALL', // 对冲开票，应收列表币种：全部/RMB/USD
          paymentRadio: 'ALL', // 对冲开票，应付列表币种：全部/RMB/USD
          showChargeDetailByInvoice: false, // ShowChargeDetailByInvoice：增值发票是否可以显示明细
          invoiceNoEditable: false, // InvoiceSearchEdit: 开票查询修改发票号
          costInfo: false, // costSplitInfo: 是否开启费用拆分金额校验
          useAutoCheckInvoicing: false, // 是否使用了自动勾选开票
          autoCheckInvoiceAmountEnable: false, // 是否使用自动勾选开票
          autoCheckInvoicingAmount: 0.00, // 自动勾选开票预设金额
          isInvoiceByEachBillingRate: false, // isInvoiceByEachBillingRate：是否按各自账单汇率来开票
          invoiceTriggerBpm: false
        }
      },
      isBpmEnabled: false,
      hmToFinanceApi: false,
      jydToFinanceApi: false,
      syncCloudPlatAble: true, // 能否访问U8接口
      qlToFinanceApi: false, // 青旅
      // 自定义分组汇总内容
      customsColumnDefs: [
        // 分币种
        {
          field: 'currencyAmount',
          getContent: rows => {
            const content = rows.reduce((acc, row) => {
              const [key, value] = (row.currencyAmount || '').split(':')
              if (key && !isNaN(value)) {
                acc[key] = (acc[key] || 0) + Number(value)
              }
              return acc
            }, {})
            return Object.entries(content)
              .map(([key, value]) => `${key}:${value.toFixed(2)}`)
              .join(', ')
          }
        }
      ],
      sumColumnDefs: [
        {
          field: 'amount',
          getValue: data => data.amount,
          format: value => formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(value), 2)
        },
        {
          field: 'verifiedAmount',
          getValue: data => data.verifiedAmount,
          format: value => formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(value), 2)
        },
        {
          field: 'unverifiedAmount',
          getValue: data => data.unverifiedAmount,
          format: value => formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(value), 2)
        },
        {
          field: 'taxAmount',
          getValue: data => data.taxAmount,
          format: value => formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(value), 2)
        },
        {
          field: 'excludingTaxAmount',
          getValue: data => data.excludingTaxAmount,
          format: value => formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(value), 2)
        }
      ],
      // 预览凭证
      accountingEntryWindow: {
        visible: false,
        index: -1,
        accountSet: null,
        rowData: [],
        prefixDataProvider: [],
        accountTitleDataProvider: [],
        mappingDepartments: [],
        mappingStaffs: [],
        isExt: false
      },
      toExoSystemTp: false,
      instructioinBtns: []
    }
  },
  computed: {
    totalDetailExpandClass() {
      return { 'el-icon-d-arrow-left': this.totalDetailDialog.show, 'el-icon-d-arrow-right': !this.totalDetailDialog.show, 'el-icon--right': true }
    },
    // 百旺金穗云
    isBwjsy() {
      return this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceName === InvoiceConstant.INVOICE_BWJSY
    },
    isHtxx() { // 航天信息
      return this.properties.interfaceNameEI === InvoiceConstant.INVOICE_HTXX || this.properties.interfaceName === InvoiceConstant.INVOICE_HTXX
    },
    isTaxEasyThreePlus() { // 容津全电
      return this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS
    },
    showEasyPaperTicketPrint() {
      return this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE && this.properties.interfaceName === InvoiceConstant.INVOICE_TAX_EASY_THREE
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return RateUtil.useOrderCenterMode()
    },
    // 是否支持全电
    isFei() {
      return this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_AISINO_EI || this.properties.toExoSystemYGSH
    },
    columnDefs() {
      const columnDefs = [
        {
          headerName: '', width: 55, checkboxSelection: params => !!params.data,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Invoice.invoice_invoiceNo'), field: 'invoiceNo', width: 130, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_invoiceHeader'), field: 'title', width: 200, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_businessNumber'), field: 'jobNo', enableRowGroup: true,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'multi-router-and-print',
            attrs: params => {
              const data = params.data
              return {
                useRoute: true,
                usePrint: true,
                jumpMethod: value => {
                  jumpFinaceOrBusiness(this, value, '', data.branchId)
                },
                printMethod: this.toSearchTemplate
              }
            }
          }, width: 150 },
        { headerName: 'MBL', field: 'mbl', width: 130, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_settlementCompany'), field: 'accountId', enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId')
          }, width: 200 },
        { headerName: this.$t('Invoice.invoice_inputBy'), field: 'createdBy', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_dateCreated'), field: 'dateCreated', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }, width: 150 },
        { headerName: this.$t('Invoice.invoice_actualReceiptDate'), field: 'actualReceiptDate', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('Invoice.invoice_approvedStatue'), field: 'isReview', enableRowGroup: true,
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.actAmountApproveLabelFun2(stringToBool(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_approvedBy'), field: 'auditor', width: 100, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_dateApproved'), field: 'reviewDate', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('Invoice.invoice_invoiceCategory'), field: 'makeType', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.electronicInvoiceColumnFunc(Number(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_incomePayDate'), field: 'incomePayDate', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.incomePayDateCommonLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.incomePayDateCommonLabelFunc(params.data)
          },
          width: 120
        },
        {
          headerName: this.$t('SeaExport.TaxNature'),
          field: 'taxNature',
          colId: 'taxNature',
          cellRenderer: params => {
            return this.taxNatureLabelFunction(params.value)
          },
          width: 120
        },
        { headerName: this.$t('Invoice.invoice_electronicInvoiceDownload'),
          cellRenderer: (params) => {
            if (params.data.makeType === 1) {
              const self = this
              const eDiv = document.createElement('div')
              let msg = '<span><button class="btnDownload" style="margin-left: 20px;">PDF</button>'
              if (params.data.webOfdUrl) {
                msg += '<button class="btnDownloadOfd" style="margin-left: 20px;">OFD</button>'
              }
              if (params.data.webXmlUrl) {
                msg += '<button class="btnDownloadXml" style="margin-left: 20px;">XML</button>'
              }
              msg += '<a class="clickDownload" style="margin-left: 20px;">' + params.data.downloadSize + this.$t('CargoMsg.Cargo_Times') + '<a/></span>'
              eDiv.innerHTML = msg
              const btnDownload = eDiv.querySelectorAll('.btnDownload')[0]
              btnDownload.addEventListener('click', function() { self.downElectronicInvoiceHandler(params.data) })
              if (params.data.webOfdUrl) {
                const btnDownloadOfd = eDiv.querySelectorAll('.btnDownloadOfd')[0]
                btnDownloadOfd.addEventListener('click', function() { self.btnDownloadOfdHandler(params.data) })
              }
              if (params.data.webXmlUrl) {
                const btnDownloadXml = eDiv.querySelectorAll('.btnDownloadXml')[0]
                btnDownloadXml.addEventListener('click', function() { self.btnDownloadXmlHandler(params.data) })
              }
              const clickDownload = eDiv.querySelectorAll('.clickDownload')[0]
              clickDownload.addEventListener('click', function() { self.clickDownloadSize(params.data) })
              return eDiv
            } else {
              return ''
            }
          },
          filter: false,
          filterParams: {},
          width: 120
        },
        {
          headerName: this.$t('Partners.isFba'),
          colId: 'fba',
          field: 'fba',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.fbaWarehouseCode'),
          colId: 'warehouseCode',
          field: 'warehouseCode',
          width: 180,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('FbaJob.DestinationDistribution'),
          colId: 'destinationDistribution',
          field: 'destinationDistribution',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.multipleFbaDestinationDistribution(TYPE_NAMES.local_cache_FbaJobConstants$DESTINATION_DISTRIBUTION_LIST, 'code', params.value)
          }
        },
        {
          headerName: this.$t('FbaJob.ExpressNo'),
          colId: 'expressNo',
          field: 'expressNo',
          width: 180,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('FbaJob.RemoteWarehouse'),
          colId: 'remoteWarehouse',
          field: 'remoteWarehouse',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        {
          headerName: 'Shipment Id',
          colId: 'shipmentId',
          field: 'shipmentId',
          width: 180,
          hide: true
        },
        {
          headerName: 'Reference Id',
          colId: 'referenceId',
          field: 'referenceId',
          width: 180,
          hide: true
        },
        { headerName: this.$t('Invoice.invoice_mailSend'),
          cellRenderer: (params) => {
            if (params.data.makeType === 1) {
              const eDiv = document.createElement('div')
              eDiv.innerHTML = '<span><button class="btnSendMail">' + this.$t('Invoice.invoice_sendEmail') + '</button><button class="btnMailLog" style="margin-left: 10px;">' + this.$t('Invoice.invoice_sendEmailLog') + '</button></span>'
              const btnSendMail = eDiv.querySelectorAll('.btnSendMail')[0]
              const self = this
              btnSendMail.addEventListener('click', function() { self.clickSendMailHandler(params.data) })
              const btnMailLog = eDiv.querySelectorAll('.btnMailLog')[0]
              btnMailLog.addEventListener('click', function() { self.clickMailLogHandler(params.data) })
              return eDiv
            } else {
              return ''
            }
          },
          filter: false,
          filterParams: {},
          width: 120
        },
        { headerName: this.$t('Invoice.invoice_downloadTimes'), field: 'downloads',
          cellRenderer: (params) => {
            if (params.data.makeType === 1) {
              return params.value + this.$t('Clearing.SecondaryDownload')
            } else {
              return ''
            }
          },
          filter: false,
          filterParams: {},
          width: 140
        },
        { headerName: this.$t('Invoice.invoice_invoiceDate'), field: 'invoiceDate', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('Invoice.invoice_billPaymentNo'), field: 'billPaymentNo', width: 120, enableRowGroup: true },
        { headerName: 'ETD', field: 'etd', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 120
        },
        { headerName: 'ETA', field: 'eta', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 120
        },
        {
          headerName: 'ATD',
          colId: 'atd',
          field: 'atd',
          width: 120,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        },
        {
          headerName: 'ATA',
          colId: 'ata',
          field: 'ata',
          width: 120,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        },
        { headerName: 'SO NO', field: 'soNo', width: 130,
          cellRenderer: (params) => {
            if (params.value) {
              return params.value
            }
            return ''
          },
          hide: true, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_proofDate'), field: 'voucherExportDate', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('Invoice.invoice_portOfDestination'), colId: 'pod2', field: 'pod2Label', enableRowGroup: true,
          filter: false,
          filterParams: {},
          width: 120
        },
        { headerName: this.$t('Invoice.invoice_writeOffStatus'), field: 'realClearingState', enableRowGroup: true,
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.clearingStateLabFun(Number(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_redChargesStatus'), field: 'invoiceState', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.invoiceOffsetLabelFun(Number(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_printOrNot'), field: 'isPrinted', enableRowGroup: true,
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.printedStatelabelFunc(stringToBool(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_invalidOrNot'), field: 'isRevoked', enableRowGroup: true,
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.revokedState(stringToBool(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_vesselAndVoyage'), field: 'vesselVoyage', width: 180, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_portOfLoading'), colId: 'pol', field: 'polLabel', enableRowGroup: true,
          filter: false,
          filterParams: {},
          width: 120
        },
        { headerName: this.$t('Invoice.invoice_exportOrNot'), field: 'isExportToInterface', enableRowGroup: true,
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.exportStateLabelFunc(stringToBool(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_invoiceType'), field: 'invoiceType', enableRowGroup: true,
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.invoiceTypeFunc(Number(params.value))
          }, width: 130 },
        { headerName: this.$t('Invoice.invoice_invoicingMethod'), field: 'mergeType', enableRowGroup: true,
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.invoiceMergeTypeFunc(Number(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_revenueAndExpenditureType'), field: 'isAr', enableRowGroup: true,
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.chargeReceivableLabelFun(stringToBool(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_invoicingCurrency'), field: 'currency', width: 100, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_invoiceExchangeRate'), field: 'invoiceRate', width: 100 },
        { headerName: this.$t('Invoice.invoice_amount'), field: 'amount',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          }, width: 100,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.invoice_theAmountOfWriteOffs'), field: 'verifiedAmount',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          }, width: 100,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.invoice_amountNotWrittenOff'), field: 'unverifiedAmount', hide: true,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          }, width: 100,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.billingJob_taxRate'), field: 'taxRate', enableRowGroup: true,
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.formatNumber(Number(params.value), 2)
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_taxAmount'), field: 'taxAmount',
          cellRenderer: (params) => {
            return ColumnUtils.formatNumber(params.value, 2)
          }, width: 100,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.invoice_taxFreeAmount'), field: 'excludingTaxAmount',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          }, width: 100,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.invoice_invoiceApplicant'), field: 'billingInputBy', width: 100, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_totalCurrency'), field: 'currencyAmount', width: 150,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.invoice_notWrittenOffTotalCurrency'), field: 'unverifiedAmountStr', hide: true, width: 150,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.invoice_operation'), field: 'jobOpName', width: 100, enableRowGroup: true,
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        { headerName: this.$t('Invoice.invoice_sales'), field: 'jobSalesName', width: 100, enableRowGroup: true,
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        { headerName: this.$t('Invoice.invoice_sellTitle'), field: 'sellTitle', width: 150, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_placeOfDelivery'), colId: 'destinationPortCode', field: 'destinationPortCodeLabel', enableRowGroup: true,
          filter: false,
          filterParams: {},
          width: 120
        },
        { headerName: this.$t('Invoice.invoice_settleDepartmentPrefix'), field: 'settleDepartment', hide: true, width: 120, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_invoiceVoider'), field: 'revokedBy', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_invoiceVoidTime'), field: 'revokedDate', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('Invoice.invoice_invoiceRemarks'), field: 'remark', hide: true, width: 200, enableRowGroup: true },

        { headerName: this.$t('Invoice.invoice_targetVoucherNo'), field: 'targetVoucherNo2Charge', hide: true, width: 100, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_voucherDate'), field: 'voucherDate2Charge', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_VoucherStatus'), field: 'voucherState', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.voucherStateLabelFunc(params.value)
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_OperationTime'), field: 'customsDate', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('Invoice.invoice_billNo'), field: 'billingNos', hide: true, width: 100, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_accountStatementNo'), field: 'billingGroupNos', hide: true, width: 100, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_sp8'), field: 'bank', width: 300, enableRowGroup: true },
        { headerName: this.$t('Invoice.OurBankCurrency'), field: 'bankCurrency', width: 300, enableRowGroup: true },
        { headerName: this.$t('SeaExport.CustomerService'), field: 'jobCsrName', width: 100, hide: true, enableRowGroup: true,
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        { headerName: this.$t('Invoice.ElInvoiceSendPlatformStatus'), field: 'sendStatus', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.sendStatusLabelFunc(params.data)
          }
        },
        { headerName: this.$t('Invoice.ElInvoiceSendEmailStatus'), field: 'sendEmailStatus', width: 200,
          cellRenderer: (params) => {
            const isZh = $store.getters.language === 'zh'
            if (params.data.makeType === 1 && params.data.sendEmailStatus === 1) {
              return isZh ? '已发送' : 'Sent'
            } else {
              return isZh ? '未发送' : 'Not sent'
            }
          }
        },
        { headerName: this.$t('Invoice.RequestTaxControlPlatformStatus'), field: 'exportToGoldenTax', width: 200, hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return stringToBool(params.value) ? this.$t('Message.Yes') : this.$t('Message.No')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
          colId: 'cooperatebranch',
          field: 'cooperatebranch',
          width: 160, minWidth: 160,
          hide: !this.useOrderCenterMode,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
          colId: 'cooperateBusinessType',
          field: 'cooperateBusinessType',
          width: 200, minWidth: 200,
          hide: !this.useOrderCenterMode,
          enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_FinancialRemarks'), field: 'remark2', hide: true, width: 200, enableRowGroup: true },
        { headerName: this.$t('Invoice.SpecificConstraintTypes'), field: 'specificConstraintType', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.specificConstraintType(params.value)
          }
        },
        /* { headerName: this.$t('Invoice.FeiRedApplicationStatus'), field: 'redOffsetState', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.feiRedApplicationStatus(Number(params.value))
          }
        },*/
        { headerName: this.$t('Invoice.RedFlushReason'), field: 'redOffsetReason', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.fedFlushReason(params.value)
          }
        },
        { headerName: this.$t('Invoice.FailureDescription'), field: 'returnTaxMsg', width: 200 },
        {
          headerName: this.$t('Billing.BillSettlementType'),
          field: 'settlementTypes',
          initialWidth: 120,
          cellRenderer: (params) => {
            return ColumnUtils.billSettlementTypesLableFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DocumentCode'), field: 'feedbackUniqueId', width: 200, hide: true },
        { headerName: this.$t('CargoMsg.Cargo_SendSharingCenter'), field: 'sendState', hide: true, width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.SHARED_TYPES)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PushDate'), field: 'sendDate', hide: true, width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PushLog'), field: 'feedbackState', hide: true, width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            if (params.data.state !== 1) {
              const uuid = params.data.uuid
              const methodOnFileViewPath = this.documentManage.getPath('onView')
              return `<a onclick="${methodOnFileViewPath}('${uuid}')" style="color:blue">
                    ${this.$t('CargoMsg.Cargo_View')}
                    </a>`
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ApprovalStatus'),
          field: 'approvalStatus',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.approvalStatusLabelFun(params.value)
          },
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_InvoiceID'),
          colId: 'invoiceId',
          field: 'invoiceId',
          initialWidth: 180
        },
        {
          headerName: this.$t('WriteOff.writeOffSerialNumber'),
          field: 'actualAmountNo',
          colId: 'actualAmountNo',
          width: 140
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayReceiveDate'), field: 'payReceiveDate', width: 180,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessReferenceNo'),
          field: 'customerRefNo',
          width: 200,
          hide: true
        },
        { headerName: this.$t('CargoMsg.Cargo_ItemNo'),
          field: 'poNo',
          width: 200,
          hide: true
        },
        { headerName: this.$t('Payment.settlementType'),
          field: 'settlementType',
          width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.settlementTypeCommonLabelFunc(params.data)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_InvoicedBy'), field: 'inputBy',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          width: 100,
          hide: true
        },
        { headerName: this.$t('Invoice.invoice_chargeCurrencyRate1'), field: 'chargeCurrencyRate1', width: 140 },
        { headerName: this.$t('Invoice.invoice_chargeCurrencyRate2'), field: 'chargeCurrencyRate2', width: 140 },
        { headerName: this.$t('Invoice.PaymentMethodVietnam'), field: 'paymentMethod', initialWidth: 120, minWidth: 120, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.paymentMethodVietnamLabelFun(params.value)
          }
        },
        { headerName: this.$t('Invoice.InvoiceStateVietnam'), field: 'invoiceStatusVietnam', initialWidth: 140, minWidth: 140, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.invoiceStatusVietnamLabelFun(Number(params.value))
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CustomJobType'),
          field: 'customJobType',
          width: 140,
          hide: true,
          enableRowGroup: true,
          valueGetter: (params) => {
            return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.customJobType, 'name', params.data.lob, params.data.fba)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Project'),
          colId: 'goodsName',
          field: 'goodsName',
          width: 180,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('FinanceManage.CostType'),
          colId: 'costControlType',
          field: 'costControlType',
          width: 120,
          valueFormatter: (params) => {
            const isZh = $store.getters.language === 'zh'
            return ColumnUtils.resolveCostType(params.value, isZh ? 'chineseName' : 'englishName')
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReceiptPaymentpVoucher') + this.$t('CargoMsg.Cargo_Date'),
          field: 'receiptPaymentpVoucherDate',
          colId: 'receiptPaymentpVoucherDate',
          hide: true,
          width: 200,
          cellRendererFramework: 'VoucherDatePopover'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReceiptPaymentpVoucher') + this.$t('CargoMsg.Cargo_Status'),
          field: 'receiptPaymentpVoucherStatus',
          colId: 'receiptPaymentpVoucherStatus',
          hide: true,
          width: 200,
          cellRendererFramework: 'VoucherDatePopover'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvoiceNature'),
          colId: 'invoiceNature',
          field: 'invoiceNature',
          width: 120,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.columnLabelFunc(InvoiceConstant.INVOICE_NATURE_LIST, params.value)
          }
        },
        {
          headerName: this.$t('Clearing.ReceivablesVerificationStatus'),
          field: 'receivableJobVerifyState',
          width: 150,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.columnLabelFunc(ClearingConstants.RECEIVABLE_VERIFY_STATES, params.value)
          }
        }
      ]
      if (this.isBpmEnabled) {
        columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_ApprovalSerialNumber'),
          field: 'documentProcessNo',
          colId: 'documentProcessNo',
          width: 200,
          hide: true,
          excelRenderer: (params) => {
            if (params.value) {
              return params.value
            }
            return ''
          },
          cellRenderer: (params) => {
            if (params.value) {
              const methodPath = this.documentManage.getPath('showWorkFlowApplyDialog')
              return `<a onclick="${methodPath}(${params.data.documentProcessId})" style="color:blue">` + params.value + '</a>'
            }
            return ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.documentProcessNo ? params.data.documentProcessNo : ''
          }
        })
      }
      if (this.jinRongExchangeMode) {
        columnDefs.push(
          {
            headerName: this.$t('CargoMsg.Cargo_CloudPlatformSyncStatus'),
            colId: 'jdyxkSyncStatus',
            field: 'jdyxkSyncStatus',
            initialWidth: 100,
            valueFormatter: (params) => {
              return ColumnUtils.jdyxkSyncStatusLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.SyncExceptionReason'),
            colId: 'jdyxkSyncFailReason',
            field: 'jdyxkSyncFailReason',
            initialWidth: 200
          }
        )
      }
      if (this.hmToFinanceApi || this.jydToFinanceApi || this.qlToFinanceApi) {
        columnDefs.push(
          {
            headerName: this.$t('Clearing.SyncCloudPlatformStatus'),
            field: 'syncExternalStatus',
            initialWidth: 100,
            valueFormatter: (params) => {
              return ColumnUtils.hmYongYouSyncStatusLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.SyncExceptionReason'),
            field: 'syncExternalFailReason',
            initialWidth: 200
          }
        )
      }
      return columnDefs
    },
    isNuoNuo() { // 诺诺全电
      return this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO
    },
    isAisinoEi() { // 航信全电
      return this.properties.interfaceNameEI === InvoiceConstant.INVOICE_AISINO_EI
    },
    // 显示销售折让
    showSalesReturn() {
      return this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO
    }
  },
  watch: {
    async isShow(newVal) {
      if (newVal) {
        // 刷新时默认页签没变，不会重新加载。恢复到created
        // await cache.load(cacheName.CONFIG)
        // // 配置参数
        // this.initConfig()
      }
    },
    allowTwoYearOutside(val) {
      if (val) {
        this.$confirm(this.$t('Invoice.invoice_unlockInvoiceDateQuery'), this.$t('CargoMsg.Cargo_ConfirmR'), { type: 'warning' }).catch(() => {
          this.allowTwoYearOutside = false
        })
      } else {
        this.searchConditions.inputDateStart = moment().subtract(2, 'y').format('yyyy-MM-DD')
      }
    },
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await cache.load(cacheName.CONFIG)
        this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
        this.jinRongExchangeMode = cache.config.get('ToExoSystem') === 'JinRongExchangeMode' // 锦荣交单模式
        this.hmToFinanceApi = cache.hqConfig.get('ToFinanceApi') === 'HM' // 上海虹迈
        this.jydToFinanceApi = cache.config.get('ToFinanceApi') === 'JYDYY' // 集翊达用友U8CLOUD
        this.toExoSystemTp = cache.config.get('ToExoSystem') === 'TP'
        this.qlToFinanceApi = cache.config.get('ToFinanceApi') === 'QL' // 青旅202507
        await this.initCustomSearchItems()
      }
    }
  },
  async created() {
    try {
      await existWorkflowGroup({
        officeId: this.$store.getters.currentOfficeId,
        formSubtype: MAKE_INVOICE_INTERNAL_INVOICE.code
      }).then(async res => {
        this.properties.invoiceTriggerBpm = res.data
      })
      const invoiceBpmEnable = await WorkflowUtil.isBpmEnabled({
        documentConfigId: MAKE_INVOICE.code,
        officeId: this.$store.getters.currentOfficeId,
        formSubtype: MAKE_INVOICE_INTERNAL_INVOICE.code
      })
      if (invoiceBpmEnable) {
        this.isBpmEnabled = invoiceBpmEnable
      } else {
        this.isBpmEnabled = await WorkflowUtil.isBpmEnabled({
          documentConfigId: COLLECT_INVOICE.code,
          officeId: this.$store.getters.currentOfficeId
        })
      }
    } catch (e) {
      // error
    }
    await cache.load(cacheName.CONFIG)
    await this.initConfig()
    await ensureExecuteSuccess(() => this.defaultSearchItems && this.defaultSearchItems.length > 0)
    await this.initCustomSearchItems()
    await this.setPaymentType()
    this.storageURL = cache.config.get('StorageURL')
    this.setLocalCurrency()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('toSearchTemplate', function(value) {
      context.toSearchTemplate(value)
    })
    this.documentManage.set('onView', function(value) {
      context.onView(value)
    })
    this.documentManage.set('showWorkFlowApplyDialog', function(documentProcessId) {
      WorkflowUtil.showWorkFlowApplyDialog(context, context.workFlowApplyDialog, 'workFlowApplyDialog', documentProcessId)
    })
  },
  mounted() {
    this.scrollCallback()
    document.querySelector('.queryInvoice').addEventListener('scroll', this.scrollCallback)
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    disabledDate(currDate) {
      if (!this.allowTwoYearOutside) {
        const beforeTwoYear = moment().subtract(2, 'y').subtract(1, 'days')
        return currDate < beforeTwoYear
      }
      return false
    },
    async setPaymentType() {
      // 全部】>【应付】>【应收】
      // 存在哪个取哪个
      // 当【全部】【应付】【应收】都不存在时候不查出任何数据
      if (!this.$checkPermission(['button_tabQueryInvoice_allCharge']) && !this.$checkPermission(['button_tabQueryInvoice_arCharge']) && !this.$checkPermission(['button_tabQueryInvoice_apCharge'])) {
        this.searchConditions.paymentType = 2
      } else if (this.$checkPermission(['button_tabQueryInvoice_allCharge'])) {
        this.searchConditions.paymentType = -1
      } else if (this.$checkPermission(['button_tabQueryInvoice_apCharge'])) {
        this.searchConditions.paymentType = 0
      } else if (this.$checkPermission(['button_tabQueryInvoice_arCharge'])) {
        this.searchConditions.paymentType = 1
      } else {
        this.searchConditions.paymentType = -1
      }
    },
    // 配置参数
    async initConfig() {
      this.invoiceHasAllowedInvalid = Number(cache.config.get('WriteOffInvoiceHasAllowedInvalid')) === 1
      this.customizeRevokeInvoiceAutoCharge = Number(cache.config.get('customizeRevokeInvoiceAutoCharge'))
      this.properties.enableCustomizeRevokeInvoice = Number(cache.config.get('enableCustomizeRevokeInvoice')) === 1
      this.properties.interfaceName = String(cache.config.get('TaxControlInterfaceName'))
      this.properties.interfaceNameEI = String(cache.config.get('EITaxControlInterfaceName'))
      this.properties.terminalSn = String(cache.config.get('baiWangOriginTerminalSN'))
      this.properties.storageURL = String(cache.config.get('StorageURL'))
      this.properties.showChargeDetailByInvoice = Number(cache.config.get('ShowChargeDetailByInvoice')) === 1
      this.properties.invoiceNoEditable = String(cache.config.get('InvoiceSearchEdit')) === '1'
      this.properties.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
      this.properties.toExoSystemHC = String(cache.config.get('ToExoSystem')) === 'HC' // 海创
      this.properties.QdWarning = String(cache.config.get('QdWarning')) !== '0' // 全电接口-国税应急方案
      this.properties.FeiByAuth = Number(cache.config.get('FeiByAuth')) === 1 // 全电接口是否走实人认证
      this.properties.settlementCenterMode = String(cache.config.get('SettlementCenterMode')) === '1' // 锦昶共享中心
      this.properties.isEasyInoivceVietnam = this.properties.interfaceNameEI === InvoiceConstant.INVOICE_EASY_INOIVCE_VIETNAM // 杰贝越南税控
      this.properties.isBillPreInvoicing = String(cache.config.get('BillingNoteContainInvoiceReques')) // 太平账单预开发票
      this.properties.toExoSystemOJ = String(cache.config.get('ToExoSystem')) === 'OJ' // 欧坚
      this.accountingEntryWindow.isExt = Number(cache.config.get('ext')) === 1
      this.properties.autoGenerateVoucher = Number(cache.config.get('AutomaticallyGenerateVouchers')) === 1
      this.toExoSystemTp = String(cache.config.get('ToExoSystem')) === 'TP'
      this.loadInstructionButtons()
    },
    // 加载指令按钮
    async loadInstructionButtons() {
      const res = await getInstructions({
        pageType: UICustomConstants.INVOICE_QUERY,
        branchId: this.$store.getters.currentOfficeId,
        useHqSet: true
      })
      this.instructioinBtns = res.data
    },
    async fetchData(conditions, simpleTriggerMode = false) {
      await this.initConfig()
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      // paymentType特殊处理，2表示没有分配查询全部、应收、应付的权限
      if (this.searchConditions.paymentType === 2) {
        return
      }
      // 是否查询受控费用
      if (!this.showControlledCharge) {
        // 是否有应付受控费用权限
        const isControlled = this.$checkPermission(['button_Charge_controlled'])
        // 是否有应收受控费用权限
        const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
        let value = 0
        if (!isControlled && !isCostControlled) {
          value = 1
        } else if (!isControlled) {
          value = 2
        } else if (!isCostControlled) {
          value = 3
        }
        if (value !== 0) {
          const option = new AdvancedSearchOption(null, 'cIsControlled', value, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        }
      }
      // 高级查询条件组装
      if (!simpleTriggerMode) {
        const advConditions = lodash.cloneDeep(conditions)
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(advConditions)
        const condition = {}
        // 是否超期
        if (AdvancedSearchOption.hasField('isExtended', advConditions)) {
          const option = AdvancedSearchOption.getOption('isExtended', advConditions)
          condition.isExtended = option.value
          AdvancedSearchOption.removeOption('isExtended', advConditions)
        }
        // 收付期限
        if (AdvancedSearchOption.hasField('incomeCostDate', advConditions)) {
          const option = AdvancedSearchOption.getOption('incomeCostDate', advConditions)
          const optionValue = Object(option.value) // type=date,start=2020-11-06,end=2020-11-28
          optionValue.split(',').forEach(function(item) {
            if (item.indexOf('start=') > -1) {
              condition.incomePayBeginDate = item.replace('start=', '')
            }
            if (item.indexOf('end=') > -1) {
              condition.incomePayEndDate = item.replace('end=', '')
            }
          })
          AdvancedSearchOption.removeOption('incomeCostDate', advConditions)
        }
        // 收付区间
        if (AdvancedSearchOption.hasField('incomeCostRange', advConditions)) {
          const option = AdvancedSearchOption.getOption('incomeCostRange', advConditions)
          condition.incomeCostRangeOperate = option.operator
          condition.incomeCostRange = option.value
          AdvancedSearchOption.removeOption('incomeCostRange', advConditions)
        }
        this.searchConditions.snapshotCondition = condition
        //
        finallyConditions.push(...advConditions)

        if (this.searchConditions.paymentType !== -1) {
          const option = new AdvancedSearchOption(null, 'invoice.AR', this.searchConditions.paymentType, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        }
        if (this.searchConditions.invoiceNoState !== -1 && !AdvancedSearchOption.hasField('invoice.INVOICENO', conditions)) {
          const option = new AdvancedSearchOption(null, 'invoice.INVOICENO', '', (this.searchConditions.invoiceNoState === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code))
          finallyConditions.push(option.formatObj2Json())
        }
        if (this.searchConditions.jobStates.length > 0 && !AdvancedSearchOption.hasField('job.JOB_STATE', conditions)) {
          const option = new AdvancedSearchOption(null, 'job.JOB_STATE', this.searchConditions.jobStates, OperatorConstants.OPERATOR_IN.code)
          finallyConditions.push(option.formatObj2Json())
        }
        if (this.searchConditions.clearingState !== -1) {
          const option = new AdvancedSearchOption(null, 'charge.PAID_OFF', this.searchConditions.clearingState, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        }
        if (this.searchConditions.exceptKeys.length > 0) {
          const option = new AdvancedSearchOption(null, 'invoice.UUID', this.searchConditions.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
          finallyConditions.push(option.formatObj2Json())
        }
        if (this.searchConditions.selectedEntitiesForHedging.length > 0) {
          const option = new AdvancedSearchOption(null, 'selectedEntitiesForHedging', this.searchConditions.selectedEntitiesForHedging, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        }
        // 开票日期
        let inputDate = ''
        if (this.searchConditions.inputDateStart && this.searchConditions.inputDateEnd) {
          inputDate = 'start=' + this.searchConditions.inputDateStart + ' 00:00:00' + ',end=' + this.searchConditions.inputDateEnd + ' 23:59:59'
        } else if (!this.searchConditions.inputDateStart && this.searchConditions.inputDateEnd) {
          inputDate = 'end=' + this.searchConditions.inputDateEnd + ' 23:59:59'
        } else if (this.searchConditions.inputDateStart && !this.searchConditions.inputDateEnd) {
          inputDate = 'start=' + this.searchConditions.inputDateStart + ' 00:00:00'
        }
        if (inputDate) {
          const condition = new AdvancedSearchOption(null, 'invoice.INVOICEDATE', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
          finallyConditions.push(condition.formatObj2Json())
        }
      } else {
        finallyConditions.push(...conditions)
      }
      // 内结
      if (this.searchConditions.internalCharge) {
        const condition = new AdvancedSearchOption(null, 'charge.INTERNAL', true, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      console.log(finallyConditions)
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      this.toQueryInvoiceList()
    },
    async fetchDataBykeyWord(keyWord) {
      console.log('fetchDataBykeyWord', keyWord)
      if (!StrUtils.isEmpty(keyWord)) {
        const conditions = []
        const option = new AdvancedSearchOption(null, 'invoice.INVOICENO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
        conditions.push(option.formatObj2Json())
        //
        this.appendQuery = false // 关闭追加查询
        await this.fetchData(conditions, true)
      }
    },
    toQueryInvoiceList() {
      this.queryOfficeId = this.$store.getters.currentOfficeId
      const { snapshotConditions: conditions, requires: requires, snapshotCondition: condition, pageNum, pageSize } = this.searchConditions
      if (this.showFba) { requires.push('fba') }
      if (this.jinRongExchangeMode) {
        requires.push('jinRongExchangeMode')
      }
      if (this.isBpmEnabled) {
        requires.push('bpm')
      }
      if (this.hmToFinanceApi) {
        requires.push('hmToFinanceApi')
      }
      if (this.jydToFinanceApi) {
        requires.push('jydToFinanceApi')
      }
      if (this.qlToFinanceApi) {
        requires.push('qlToFinanceApi')
      }

      const requestBody = { conditions, requires, condition, branchId: this.$store.getters.currentOfficeId, pageNum, pageSize, 'requestSource': 'Invoice' }
      requestBody.appendQuery = this.appendQuery
      this.loading = getLoading()
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
      queryInvoiceList(requestBody).then(res => {
        let results = res.data.list
        if (results && results.length > 0) {
          // 追加查询数据去重
          if (this.appendQuery) {
            results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
          }
        }
        this.rowData = results
        this.searchConditions.total = this.appendQuery ? results.length : Number(res.data.total)
        this.totalAmountToCurrency.chargeTotalData = res.data.chargeTotal || []
        this.totalAmountToCurrency.dataProvider = results
        selectedStatus.revert()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 分页触发查询
    fetchDataByPage() {
      this.toQueryInvoiceList()
    },
    // 展示表格首列【业务编号】单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
      // 需要根据value装配this.templateSelectorDialog中相关内容(done)
      if (value) {
        // TemplateSelectorWin.getInstance().showThisWin(job, "JOB_DETAIL", {"JOB_UUID":job.key}, FlexGlobals.topLevelApplication as DisplayObject);
        this.templateSelectorDialog.cxt = this.rowData.find(item => item.uuid === value)
        this.templateSelectorDialog.data.JOB_UUID = value
        this.templateSelectorDialog.category = 'JOB_DETAIL'
        this.templateSelectorDialog.visible = true
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotFoundTemplate'))
      }
    },
    // 复核
    approveHandler() {
      const rowDataSelected = getGridSelected(this.gridOptions)
      if (rowDataSelected.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      console.log('approveHandler', rowDataSelected)
      const list = []
      for (const item of rowDataSelected) {
        if (!item.isReview) {
          const invoice = {}
          invoice.uuid = item.uuid
          invoice.review = true
          invoice.auditor = this.$store.getters.userInfo.chineseName
          list.push(invoice)
        }
      }
      if (list.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OnlyUnCheckedRecordsCanBeChecked'))
        return
      } else {
        const self = this
        self.$confirm(this.$t('CargoMsg.Cargo_ConfirmAndCheckSelectedRecord'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          self.loading = getLoading()
          approveInvoices(list).then(res => {
            const invoiceData = res.data.invoiceData
            if (invoiceData) {
              const invoiceMap = new Map()
              for (const invoice of invoiceData) {
                invoiceMap.set(invoice.uuid, invoice)
              }
              for (const row of rowDataSelected) {
                const invoice = invoiceMap.get(row.uuid)
                if (invoice) {
                  row.isReview = invoice.review
                  row.auditor = invoice.auditor
                  row.reviewDate = invoice.reviewDate
                  row.jdyxkSyncStatus = invoice.jdyxkSyncStatus
                  row.jdyxkSyncFailReason = invoice.jdyxkSyncFailReason
                }
              }
            }
            if (res.data.jinRongExchange) {
              self.$message.success(this.$t('FinanceManage.SyncCloudSucceededXFailedX', [res.data.jinRongExchange.successCount, res.data.jinRongExchange.failCount]))
            } else {
              self.$message.success(this.$t('CargoMsg.Cargo_ReCheckedSuccessfully'))
            }
            this.refreshGrid()
          }).finally(() => {
            self.loading.close()
          })
        }).catch(() => {
          //
        })
      }
    },
    // 取消复核
    unapproveHandler() {
      const rowDataSelected = getGridSelected(this.gridOptions)
      if (rowDataSelected.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      console.log('unapproveHandler', rowDataSelected)
      const list = []
      for (const item of rowDataSelected) {
        if (item.isReview) {
          const invoice = {}
          invoice.uuid = item.uuid
          invoice.review = false
          list.push(invoice)
        }
      }
      if (list.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OnlyCheckedRecordsCanBeCancelled'))
        return
      } else {
        const self = this
        self.$confirm(this.$t('CargoMsg.Cargo_CancelCheckOfSelectedRecord'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          self.loading = getLoading('app-main-content')
          approveInvoices(list).then(res => {
            // 刷新
            for (const item of rowDataSelected) {
              if (item.isReview) {
                item.isReview = false
                item.auditor = ''
                item.reviewDate = null
              }
            }
            this.refreshGrid()
            self.$message.success(this.$t('CargoMsg.Cargo_CancelSuccessfully'))
          }).finally(() => {
            self.loading.close()
          })
        }).catch(() => {
          //
        })
      }
    },
    // 强制删除
    async forceDeleteHandler() {
      if (await this.checkDeleteable(true)) {
        this.deleteInvoice(false, true)
      }
    },
    // 删除
    async deleteHandler() {
      if (await this.checkDeleteable(false)) {
        this.deleteInvoice()
      }
    },
    // 是否可删除
    async checkDeleteable(force = false) {
      console.log('checkDeleteable', force)
      const rowDataSelected = getGridSelected(this.gridOptions)
      if (rowDataSelected.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return false
      }
      if (this.jydToFinanceApi) {
        let flag = true
        for (const invoice of rowDataSelected) {
          if (invoice.syncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
            flag = await this.$confirm(this.$t('CargoMsg.Cargo_YongYouDeleteTip'), this.$t('CargoMsg.Cargo_Tips'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
              cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
              type: 'warning'
            }).then(() => true).catch(() => false)
            break
          }
        }
        if (!flag) {
          return false
        }
      }
      if (this.customizeRevokeInvoiceAutoCharge === 2) {
        if (this.invoiceHasAllowedInvalid) {
          let flag = true
          for (const invoice of rowDataSelected) {
            if (invoice.realClearingState > 0) {
              flag = await this.$confirm(this.$t('Clearing.InvoiceWrittenOffWantDeleteIt'), this.$t('CargoMsg.Cargo_Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
                cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
                type: 'warning'
              }).then(() => true).catch(() => false)
              break
            }
          }
          if (!flag) {
            return false
          }
        }
      }
      for (const invoice of rowDataSelected) {
        if (!force && invoice.isPrinted) {
          this.$message.warning(this.$t('CargoMsg.Cargo_InvoicePrintedCanTBeDeleted'))
          return false
        } else if (!force && invoice.isRevoked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_InvoiceVoidedCanTBeDeleted'))
          return false
        } else if (!force && !StrUtils.isEmpty(invoice.invoiceNo)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CanTDeleteItemsWithInvoiceNo'))
          return false
        } else if (invoice.realClearingState !== 0 && !this.invoiceHasAllowedInvalid) {
          const lb = !StrUtils.isEmpty(invoice.invoiceNo) ? invoice.invoiceNo : invoice.title
          this.$message.warning(this.$t('CargoMsg.Cargo_CanTVoidWrittenOffItem').format(lb))
          return false
        }
        if (!force && !!invoice.approvalStatus && invoice.approvalStatus !== BPM_STATES_UN_APPROVED.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DeleteUnApprovedInvoiceTips'))
          return false
        }
        if (this.hmToFinanceApi && invoice.syncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
          this.$message.warning(this.$t('Clearing.SentYongYouRedFlush'))
          return false
        }
      }
      return true
    },
    // 删除发票
    deleteInvoice(isRevoke = false, force = false) {
      console.log('deleteInvoice', isRevoke)
      const invoices = getGridSelected(this.gridOptions)
      const keys = []
      const map = new Map()
      for (const invoice of invoices) {
        keys.push(invoice.uuid)
        map.set(invoice.uuid, invoice.invoiceNo)
      }
      // 是否导出过凭证
      // CARGO-21342 如果发票做过凭证作废或者红冲时增加提醒
      this.loading = getLoading()
      checkToVoucher({ 'keys': keys }).then(res => {
        const resultKeys = res.data
        let invoiceNoStr = ''
        if (resultKeys && resultKeys.length > 0 && !this.properties.autoGenerateVoucher) {
          for (const invoiceUuid of resultKeys) {
            if (!invoiceUuid) continue
            if (!invoiceNoStr) {
              invoiceNoStr = map.get(invoiceUuid)
            } else {
              invoiceNoStr += (',' + map.get(invoiceUuid))
            }
          }
        }
        let msg = ''
        if (isRevoke) {
          // msg = '确定要作废这' + invoices.length + '张发票吗？'
          msg = this.$t('CargoMsg.Cargo_SureToVoidTheInvoiceM').format(invoices.length)
          // 杰贝越南税控
          if (this.properties.isEasyInoivceVietnam) msg = this.$t('CargoMsg.Cargo_SureToVoidTheInvoiceVietnam')
        } else {
          // msg = '确定要删除这' + invoices.length + '张发票吗？'
          msg = this.$t('CargoMsg.Cargo_SureToDeleteTheInvoice').format(invoices.length)
        }
        if (invoiceNoStr) {
          msg = (msg + '<br>' + this.$t('CargoMsg.Cargo_GeneratedVoucherInvoice') + '<br>' + invoiceNoStr)
        }
        this.$confirm(msg, this.$t('CargoMsg.Cargo_Tips'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          this.doDelete(isRevoke, null, force)
        }).catch(() => {
          //
        })
      }).finally(() => {
        this.loading.close()
      })
    },
    doDelete(isRevoke = false, copyInvoiceNo = true, force = false) {
      const keys = []
      const invoices = getGridSelected(this.gridOptions)
      for (const invoice of invoices) {
        keys.push(invoice.uuid)
        if (this.jinRongExchangeMode && isRevoke) {
          if (invoice.jdyxkSyncStatus !== ChargeConstants.JDYXK_SYNC_SUCCESS.code && invoice.jdyxkSyncStatus !== ChargeConstants.JDYXK_INVALID_FAIL.code) {
            this.$message.warning(this.$t('Invoice.CloudStarrySkyNotSync'))
            return
          }
        }
      }
      //
      if (keys.length === 0) return
      const requestBody = { 'keys': keys, 'isRevoke': isRevoke, 'copyInvoiceNo': copyInvoiceNo, 'branchId': this.$store.getters.currentOfficeId, 'force': force, 'location': this.location }
      console.log('doDelete', requestBody)
      this.loading = getLoading()
      deleteInvoices(requestBody).then(res => {
        console.log('deleteInvoices', res)
        if (isRevoke) {
          this.$message.success(this.$t('CargoMsg.Cargo_VoidedSuccessfully'))
        } else {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
        }
        // if (force) {
        //   // CARGO-34026 强制删除之后，调用bpm的删除接口
        //   const invoiceUuids = []
        //   const rowDataSelected = getGridSelected(this.gridOptions)
        //   for (const invoice of rowDataSelected) {
        //     if (invoice.approvalStatus && invoice.approvalStatus !== BPM_STATES_UN_APPROVED.code) {
        //       invoiceUuids.push(invoice.uuid)
        //     }
        //   }
        //   if (invoiceUuids.length > 0) {
        //     console.log('call bpm delete invoice document')
        //     deleteProcess({ docIds: invoiceUuids.join(',') })
        //   }
        // }
        // 刷新
        this.gridOptions.api.updateRowData({ remove: invoices })
        //
        this.deleteResultHandler(res.data)
      }).finally(() => {
        this.loading.close()
      })
    },
    deleteResultHandler(result) {
      const copyInvoiceNo = result.copyInvoiceNo
      const redPunchs = result.redPunchs
      if (redPunchs && redPunchs.length > 0 && !copyInvoiceNo) {
        this.properties.invoices = redPunchs
        this.properties.currentPage = 1
        this.pageChange('viewInvoice')
        this.step = 'step3'
        //
        this.$refs.makeInvoiceDialog.initBaseData()
      }
    },
    // 作废
    async revokeHandler() {
      if (await this.checkRevokeable()) {
        // CARGO-1439，税控对接容津：增加作废发票对接功能
        if (this.properties.enableCustomizeRevokeInvoice && !this.properties.isEasyInoivceVietnam) {
          const rowDataSelected = getGridSelected(this.gridOptions)
          for (const invoice of rowDataSelected) {
            const lb = !StrUtils.isEmpty(invoice.invoiceNo) ? invoice.invoiceNo : invoice.title
            // ①必须为纸质发票。若选中的发票中包含电子发票，则点击【作废】后弹窗提示：电子发票不可作废，请红冲
            if (invoice.makeType === 1) {
              this.$message.warning(this.$t('Clearing.N0isBeVoidedPleaseNote', [lb]))
              return false
            }
            // ②开票日期必须为当月。若选中的发票中包含发票日期不为当月的发票，则点击【作废】后弹窗提示：跨月发票不可作废，请红冲
            if (DateUtils.customFormat(invoice.invoiceDate, 'YYYY-MM') !== DateUtils.customFormat(new Date(), 'YYYY-MM')) {
              this.$message.warning(this.$t('Clearing.N0isCannotBeVoidedNote', [lb]))
              return false
            }
            // ③必须没有关联有效凭证。若选中的发票中包含已经生成有效凭证的发票，则点击【作废】后弹窗提示：已生成凭证的发票不可作废，请删除凭证，或者红冲
          }
          this.checkExportVoucherCustomize()
        } else {
          this.checkExportVoucher()
        }
      }
    },
    // 验证是否导出过财务接口
    checkExportVoucher() {
      const keys = []
      const invoices = getGridSelected(this.gridOptions)
      for (const invoice of invoices) {
        keys.push(invoice.uuid)
      }
      //
      if (keys.length === 0) return
      const requestBody = { 'keys': keys }
      console.log('checkExportVoucher', requestBody)
      this.loading = getLoading()
      checkExportedToVoucher(requestBody).then(res => {
        console.log('checkExportedToVoucher', res)
        this.checkVoucherResultHandler(res.data)
      }).finally(() => {
        this.loading.close()
      })
    },
    checkVoucherResultHandler(results) {
      if (results && results.length > 0 && !this.properties.autoGenerateVoucher) {
        this.$confirm(this.$t('CargoMsg.Cargo_FCAEFAIIVWBIWBCCTV').format(results.length), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          this.confirmRedWordInvoice()
        }).catch(() => {
          //
        })
      } else {
        this.deleteInvoice(true)
      }
    },
    confirmRedWordInvoice() {
      this.$confirm(this.$t('CargoMsg.Cargo_NTWBWRLION'), this.$t('CargoMsg.Cargo_WriteBack'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        type: 'warning'
      }).then(() => {
        this.doDelete(true, false)
      }).catch(() => {
        this.doDelete(true, true)
      })
    },
    // 验证是否导出过财务接口：作废红冲发票客户化(亚东)
    checkExportVoucherCustomize() {
      const keys = []
      const invoices = getGridSelected(this.gridOptions)
      for (const invoice of invoices) {
        keys.push(invoice.uuid)
      }
      //
      if (keys.length === 0) return
      const requestBody = { 'keys': keys }
      console.log('checkExportVoucherCustomize', requestBody)
      this.loading = getLoading()
      checkExportedToVoucher(requestBody).then(res => {
        console.log('checkExportedToVoucher', res)
        this.checkVoucherCustomizeResultHandler(res.data, keys.length)
      }).finally(() => {
        this.loading.close()
      })
    },
    checkVoucherCustomizeResultHandler(results, count) {
      if (results && results.length > 0 && !this.properties.autoGenerateVoucher) {
        this.$message.warning(this.$t('CargoMsg.Cargo_IVCNBVPDTORTI').format(results.length))
      } else {
        this.$confirm(this.$t('CargoMsg.Cargo_SureToVoidTheInvoiceM').format(count), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          this.doRevokeInvoices()
        }).catch(() => {
          //
        })
      }
    },
    doRevokeInvoices() {
      const keys = []
      const invoices = getGridSelected(this.gridOptions)
      for (const invoice of invoices) {
        keys.push(invoice.uuid)
        if (this.jinRongExchangeMode) {
          if (invoice.jdyxkSyncStatus !== ChargeConstants.JDYXK_SYNC_SUCCESS.code && invoice.jdyxkSyncStatus !== ChargeConstants.JDYXK_INVALID_FAIL.code) {
            this.$message.warning(this.$t('Invoice.CloudStarrySkyNotSync'))
            return
          }
        }
      }
      //
      if (keys.length === 0) return
      const requestBody = { 'keys': keys, 'isRevoke': true, 'copyInvoiceNo': true, 'branchId': this.$store.getters.currentOfficeId, 'location': this.location }
      console.log('doRevokeInvoices', requestBody)
      this.loading = getLoading()
      revokeInvoices(requestBody).then(res => {
        console.log('revokeInvoices', res)
        // 刷新
        for (const item of invoices) {
          if (!item.isRevoked) {
            item.isRevoked = true
            item.revokedBy = this.$store.getters.userInfo.userId
            item.revokedDate = new Date()
          }
        }
        if (res.data.jinRongExchange) {
          const newInvoices = res.data.invoices
          if (newInvoices) {
            const newInvoiceMap = new Map()
            for (const newInvoice of newInvoices) {
              newInvoiceMap.set(newInvoice.uuid, newInvoice)
            }
            for (const invoice of invoices) {
              const newInvoice = newInvoiceMap.get(invoice.uuid)
              if (newInvoice) {
                invoice.jdyxkSyncStatus = newInvoice.jdyxkSyncStatus
                invoice.jdyxkSyncFailReason = newInvoice.jdyxkSyncFailReason
              }
            }
          }
        }
        this.$message.success(this.$t('CargoMsg.Cargo_VoidedSuccessfully'))
        this.refreshGrid()
        //
        this.deleteResultHandler(res.data)
      }).finally(() => {
        this.loading.close()
      })
    },
    refreshGrid() {
      this.gridOptions.api.setRowData(this.rowData)
      this.gridOptions.api.expandAll()
    },
    // 是否可作废
    async checkRevokeable() {
      console.log('checkRevokeable')
      const rowDataSelected = getGridSelected(this.gridOptions)
      if (rowDataSelected.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return false
      }
      if (this.jydToFinanceApi) {
        let flag = true
        for (const invoice of rowDataSelected) {
          if (invoice.syncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
            flag = await this.$confirm(this.$t('CargoMsg.Cargo_YongYouDeleteTip'), this.$t('CargoMsg.Cargo_Tips'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
              cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
              type: 'warning'
            }).then(() => true).catch(() => false)
            break
          }
        }
        if (!flag) {
          return false
        }
      }
      if (this.customizeRevokeInvoiceAutoCharge) {
        if (this.invoiceHasAllowedInvalid) {
          let flag = true
          for (const invoice of rowDataSelected) {
            if (invoice.realClearingState > 0) {
              flag = await this.$confirm(this.$t('Clearing.InvoiceWrittenOffWantRevokedIt'), this.$t('CargoMsg.Cargo_Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
                cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
                type: 'warning'
              }).then(() => true).catch(() => false)
              break
            }
          }
          if (!flag) {
            return false
          }
        }
      }
      // CARGO-3080，增加校验：作废发票不支持批量操作
      if (rowDataSelected.length > 1) {
        this.$message.warning('    作废发票不支持批量操作\n请勾选一张发票再点击【作废】')
        return false
      }
      for (const invoice of rowDataSelected) {
        const lb = !StrUtils.isEmpty(invoice.invoiceNo) ? invoice.invoiceNo : invoice.title
        if (invoice.isRevoked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CanTRepeatVoiding').format(lb))
          return false
        }
        if (invoice.realClearingState !== 0 && !this.invoiceHasAllowedInvalid) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CanTVoidWrittenOffItem').format(lb))
          return false
        }
        if (!!invoice.approvalStatus && invoice.approvalStatus !== BPM_STATES_UN_APPROVED.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DeleteUnApprovedInvoiceTips'))
          return false
        }
        if (this.hmToFinanceApi && invoice.syncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
          this.$message.warning(this.$t('Clearing.SentYongYouRedFlush'))
          return false
        }
      }
      return true
    },
    // 红冲
    async redPunchHandler() {
      console.log('redPunchHandler')
      const invoices = getGridSelected(this.gridOptions)
      if (invoices.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return false
      }
      if (this.customizeRevokeInvoiceAutoCharge === 2) {
        if (this.invoiceHasAllowedInvalid) {
          let flag = true
          for (const invoice of invoices) {
            if (invoice.realClearingState > 0) {
              flag = await this.$confirm(this.$t('Clearing.InvoiceWrittenOffWantRedPunchIt'), this.$t('CargoMsg.Cargo_Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
                cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
                type: 'warning'
              }).then(() => true).catch(() => false)
              break
            }
          }
          if (!flag) {
            return false
          }
        }
      }
      const keys = []
      const map = new Map()

      // 全电校验
      const invoiceTypeSet = new Set()
      let isQd = false
      for (const invoice of invoices) {
        // 全电红冲时校验 仅支持批量同时操作相同状态的发票，请重新勾选后完成操作。【状态：红冲状态+全电红字申请状态】
        if (!isQd && invoice.invoiceType === InvoiceConstant.INVOICE_TYPE_VAT_FEI.code || invoice.invoiceType === InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code) {
          isQd = true
        }
        invoiceTypeSet.add(invoice.invoiceType)
      }
      if (isQd) {
        if (this.properties.QdWarning) {
          this.$confirm(this.$t('Invoice.QdWarningTip'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            showCancelButton: false,
            closeOnClickModal: false,
            type: 'warning'
          })
          return
        }
        for (const item of invoiceTypeSet) {
          if (item !== InvoiceConstant.INVOICE_TYPE_VAT_FEI.code && item !== InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code) {
            this.$message.warning(this.$t('Invoice.BatchCheckRedFlushInvoiceType'))
            return false
          }
        }
        // if (this.isNuoNuo) {
        //   let invoiceState = -1 // 记录发票状态 红冲时用来判断
        //   let redOffsetState = -1 // 记录红字申请状态 红冲时用来判断
        //   for (const invoice of invoices) {
        //     if (invoiceState === -1) { // 0未红冲 1被红冲 2红冲
        //       invoiceState = invoice.invoiceState
        //     }
        //     if (redOffsetState === -1) { // 0未申请、1申请中、2成功、3失败
        //       redOffsetState = invoice.redOffsetState
        //     }
        //     // 全电红冲时校验 仅支持批量同时操作相同状态的发票，请重新勾选后完成操作。【状态：红冲状态+全电红字申请状态】
        //     if (invoiceState !== invoice.invoiceState || redOffsetState !== invoice.redOffsetState) {
        //       this.$message.warning(this.$t('Invoice.BatchCheckRedFlushInvoice'))
        //       return false
        //     }
        //   }
        // }
      }

      // 平台原有逻辑
      for (const invoice of invoices) {
        const lb = !StrUtils.isEmpty(invoice.invoiceNo) ? invoice.invoiceNo : invoice.title
        if (invoice.isRevoked) {
          this.$message.warning(this.$t('Clearing.N0VoidedAndCannotCredited', [lb]))
          return false
        }
        if (invoice.realClearingState !== 0 && !this.invoiceHasAllowedInvalid) {
          this.$message.warning(this.$t('Clearing.N0hasOffAndCannotCredited', [lb]))
          return false
        }
        if (this.jinRongExchangeMode) {
          if (invoice.jdyxkSyncStatus !== ChargeConstants.JDYXK_SYNC_SUCCESS.code && invoice.jdyxkSyncStatus !== ChargeConstants.JDYXK_INVALID_FAIL.code) {
            this.$message.warning(this.$t('Invoice.InvoiceNotSyncOrInvalid'))
            return false
          }
        }
        keys.push(invoice.uuid)
        map.set(invoice.uuid, invoice.invoiceNo)
      }

      // 是否导出过凭证
      // CARGO-21342 如果发票做过凭证作废或者红冲时增加提醒
      this.loading = getLoading()
      checkToVoucher({ 'keys': keys }).then(async res => {
        this.loading.close()
        const resultKeys = res.data
        let invoiceNoStr = ''
        if (resultKeys && resultKeys.length > 0) {
          for (const invoiceUuid of resultKeys) {
            if (!invoiceUuid) continue
            if (!invoiceNoStr) {
              invoiceNoStr = map.get(invoiceUuid)
            } else {
              if (this.customizeRevokeInvoiceAutoCharge === 2) {
                invoiceNoStr += (', ' + map.get(invoiceUuid))
              } else {
                invoiceNoStr += (',' + map.get(invoiceUuid))
              }
            }
          }
        }
        if (this.customizeRevokeInvoiceAutoCharge === 2) {
          if (invoiceNoStr) {
            const isOk = await this.$confirm(this.$t('Clearing.ContinueRedPunchAtVoucher') + '<br>' + invoiceNoStr, this.$t('CargoMsg.Cargo_Tips'), {
              dangerouslyUseHTMLString: true,
              confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
              cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
              type: 'warning'
            }).then(() => true).catch(() => false)
            if (!isOk) {
              return
            }
          }
        }
        //
        let message = this.$t('Clearing.OriginalToReissueTheExpenses')
        if (this.customizeRevokeInvoiceAutoCharge) {
          message = this.$t('Clearing.OriginalTheSystemWillExpenses')
        }
        if (invoiceNoStr) {
          message = (message + '<br>' + this.$t('CargoMsg.Cargo_GeneratedVoucherInvoice') + '<br>' + invoiceNoStr)
        }
        // 全电
        if (isQd) {
          if (invoiceNoStr) {
            this.batchRedFlush.message = '<br>' + this.$t('CargoMsg.Cargo_GeneratedVoucherInvoice') + '<br>' + invoiceNoStr
          }
          this.batchRedFlush.redOffsetReason = '01'
          this.batchRedFlush.invoiceKeys = keys
          this.batchRedFlush.visible = true
        } else {
          if (this.customizeRevokeInvoiceAutoCharge === 2) {
            this.batchRedPunchDialog.redOffsetReason = 'InvoiceError'
            this.batchRedPunchDialog.invoiceKeys = keys
            this.batchRedPunchDialog.visible = true
          } else {
            this.$confirm(message, this.$t('CargoMsg.Cargo_Tips'), {
              dangerouslyUseHTMLString: true,
              confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
              cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
              type: 'warning'
            }).then(() => {
              this.doRedPunchInvoices(isQd)
            }).catch(() => {
              //
            })
          }
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    doRedPunchInvoices() {
      const keys = []
      const invoices = getGridSelected(this.gridOptions)
      for (const invoice of invoices) {
        keys.push(invoice.uuid)
      }
      //
      if (keys.length === 0) return
      const redOffsetReason = this.customizeRevokeInvoiceAutoCharge === 2 ? this.batchRedPunchDialog.redOffsetReason : ''
      const requestBody = { 'keys': keys, 'isRevoke': true, 'copyInvoiceNo': true, 'branchId': this.$store.getters.currentOfficeId, 'redOffsetReason': redOffsetReason, customizeRevokeInvoiceAutoCharge: this.customizeRevokeInvoiceAutoCharge, 'location': this.location }
      console.log('doRedPunchInvoices', requestBody)
      this.loading = getLoading()
      redPunchInvoices(requestBody).then(res => {
        console.log('redPunchInvoices', res)
        // 刷新
        for (const item of invoices) {
          if (!item.isRevoked) {
            item.invoiceState = 1 // 被红冲
            item.isRevoked = true
            item.revokedBy = this.$store.getters.userInfo.userId
            item.revokedDate = new Date()
          }
        }
        this.refreshGrid()
        this.$message.success('红冲成功！')
        //
        this.deleteResultHandler(res.data)
      }).finally(() => {
        this.batchRedPunchDialog.visible = false
        this.loading.close()
      })
    },
    // 确定红冲-全电
    confirmRedPunch() {
      const requestBody = { 'keys': this.batchRedFlush.invoiceKeys, 'isRevoke': true, 'copyInvoiceNo': true, 'branchId': this.$store.getters.currentOfficeId, 'redOffsetReason': this.batchRedFlush.redOffsetReason, customizeRevokeInvoiceAutoCharge: this.customizeRevokeInvoiceAutoCharge, 'location': this.location }
      console.log('confirmRedPunch', requestBody)
      this.loading = getLoading()
      redPunchInvoicesQd(requestBody).then(res => {
        console.log('confirmRedPunch', res)
        // 刷新
        const invoices = getGridSelected(this.gridOptions)
        for (const item of invoices) {
          if (!item.isRevoked) {
            item.invoiceState = 1 // 被红冲
            item.isRevoked = true
            item.revokedBy = this.$store.getters.userInfo.userId
            item.revokedDate = new Date()
            item.redOffsetReason = this.batchRedFlush.redOffsetReason
          }
        }
        this.gridOptions.api.refreshCells({ force: true })
        this.$message.success('红冲成功！')
        //
        this.deleteResultHandler(res.data)
      }).finally(() => {
        this.batchRedFlush.visible = false
        this.loading.close()
      })
    },
    // 导出增值税发票
    exportAVTHandler() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return
      }
      const keys = []
      for (const invoice of rows) {
        if (invoice.makeType !== 1 && invoice.invoiceType !== InvoiceConstant.INVOICE_TYPE_VAT.code && invoice.invoiceType !== InvoiceConstant.INVOICE_TYPE_VAT_DEDICATED.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectVatEiInvoice'))
          return
        }
        keys.push(invoice.uuid)
      }
      // CARGO-33161 全电发票 导入导出方式
      // 1 航天信息  2 航天金税  3 航天信息G3
      // const TaxControlInterfaceSolution = cache.config.get('TaxControlInterfaceSolution') || 1
      // window.open(`${URL.act.invoice.invoiceExport}?sessionId=${getToken()}&invoiceKeys=${keys.join(',')}&exportType=VAT&TaxControlInterfaceSolution=${TaxControlInterfaceSolution}`)
      const loading = getLoading4Cxt()
      const item = {}
      item.keys = keys
      item.branchId = this.$store.getters.currentOfficeId
      exportInvoiceQd(item).then(res => {
        const result = res.data
        this.exportResultHandler(result)
      }).finally(() => {
        loading.close()
      })
    },
    // 下载处理
    exportResultHandler(result) {
      if (!result || !result.success) {
        if (result.errMsg === 'noData') {
          this.$message.warning(this.$t('CargoMsg.Cargo_NoData'))
        } else if (result.errMsg === 'uploadFileErr') {
          this.$message.warning(this.$t('CargoMsg.Cargo_uploadErr'))
        } else {
          this.$message.error({ dangerouslyUseHTMLString: true, message: result.errMsg })
        }
        return
      }
      // 从云存储上下载文件
      if (!result.documentId) {
        this.$message.warning(this.$t('SeaExport.NoCorrespondingFile'))
        return
      }
      // const storageURL = cache.config.get('StorageURL')
      window.open(`${URL.common.findByFileId}/${result.documentId}?sessionId=${this.$store.getters.token}`)
      this.toQueryInvoiceList()
    },
    // 太平导出发票信息
    exportInvoiceDataHandler() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return
      }
      const keys = []
      for (const invoice of rows) {
        keys.push(invoice.uuid)
      }
      const loading = getLoading4Cxt()
      const item = {}
      item.keys = keys
      item.branchId = this.$store.getters.currentOfficeId
      let exportFunc = exportInvoiceDataFunc
      if (this.properties.toExoSystemOJ) {
        exportFunc = exportInvoiceDataOJFunc
      }
      exportFunc(item).then(res => {
        const result = res.data
        this.exportResultHandler(result)
      }).finally(() => {
        loading.close()
      })
    },
    // 金税导出
    async interfaceExportBatchHandler() {
      const allowTaxOperation = await BSWarningUtil.checkTaxExpire()
      if (!allowTaxOperation) {
        return
      }
      // 审批状态校验：未审批通过(approvalStatus!==3)整批拒绝，与后端 assertApprovedForGoldenTax 一致
      const approvalSelections = getGridSelected(this.gridOptions)
      const notApprovedRows = approvalSelections.filter(r => r.approvalStatus !== 3)
      if (notApprovedRows.length > 0) {
        const nos = notApprovedRows.map(r => r.invoiceNo || r.uuid).join('，')
        this.$message.warning(`以下发票未审批通过，无法金税导出：${nos}`)
        return
      }
      if (this.properties.toExoSystemYGSH) {
        const selections = getGridSelected(this.gridOptions)
        if (selections.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
          return false
        }
        this.loading = getLoading()
        const list = []
        for (const data of selections) {
          list.push(data.uuid)
        }
        queryLtsInvoiceFunc(list).then(res => {
          if (res.data === 'ok') {
            this.$message.success(this.$t('Message.SynchronizationSucceeded'))
          } else if (res.data === 'not data') {
            this.$message.warning(this.$t('Message.NoSynchronizationContent'))
          } else {
            this.$message.warning(res.data)
          }
        }).finally(() => {
          this.loading.close()
        })
      } else {
        this.realPersonAuthentication()
      }
    },
    // 实人认证
    async realPersonAuthentication(closeDialog = false) {
      if (this.getQdWarning()) {
        return
      }
      if (closeDialog) { // 认证通过关闭二维码弹框
        this.ewmDialog.visible = false
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
        return
      }
      this.doCallInterfaceBatch()
    },
    doCallInterfaceBatch(opType = 0, machinenr = 0) {
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return false
      }

      const office = this.$store.getters.currentOffice
      const itemList = []
      let exportToGoldenTax = false // 金税是否已导出
      let makeType = '' // 开票种类(0.纸质发票 1.电子发票)
      for (const invoice of selections) {
        if (invoice.exportToGoldenTax) {
          exportToGoldenTax = true
        }
        if (StrUtils.isEmpty(makeType)) {
          makeType = invoice.makeType.toString()
        } else {
          if (makeType !== invoice.makeType.toString()) {
            this.$message.warning(this.$t('CargoMsg.Cargo_VSRAOGTEPAEIADPERAPIT'))
            return
          }
        }
        //
        if (!(invoice.isAr && [2, 3, 6, 7].includes(invoice.invoiceType))) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OVICBETGTEI', ['RMB']))
          return
        }
        // 全电票红冲发票金税导出前的验证
        // invoiceState 0未红冲 1被红冲 2红冲
        // if (this.isNuoNuo && [6, 7].includes(invoice.invoiceType) && invoice.invoiceState === 2) {
        //   if (invoice.redOffsetState === Number(InvoiceConstant.RED_OFFSET_STATUS_FAIL.code)) {
        //     this.$message.warning(this.$t('Invoice.RedApplyFail'))
        //     return
        //   }
        //   if (invoice.redOffsetState === Number(InvoiceConstant.RED_OFFSET_STATUS_IN_APPLICATION.code)) {
        //     this.$message.warning(this.$t('Invoice.RedApplying'))
        //     return
        //   }
        //   if (invoice.redOffsetState !== Number(InvoiceConstant.RED_OFFSET_STATUS_SUCCESS.code)) {
        //     this.$message.warning(this.$t('Invoice.BatchCheckRedApplySuccessInvoice'))
        //     return
        //   }
        // }
        //
        const item = {}
        item.officeId = office.officeId
        item.wsdlLocation = office.sajtInvoiceService
        item.machinetaxnr = office.taxAccount
        item.machinenr = machinenr
        if (this.properties.interfaceName === 'BAI_WANG_ORIGIN' || this.isHtxx || this.isFei) {
          item.invoiceType = invoice.invoiceType
        } else {
          // 0-专用发票，2-普通发票
          item.invoiceType = invoice.invoiceType === 3 ? 0 : 2
        }
        // 1-电子发票, 0- 纸质发票
        item.invoiceMakeType = invoice.makeType
        item.uuid = invoice.uuid
        // 电子发票的
        if (makeType === '1') {
          if (invoice.currency !== 'RMB' && !this.properties.isEasyInoivceVietnam) {
            this.$message.warning(this.$t('CargoMsg.Cargo_OWCICGTSEEI', ['RMB']))
            return
          }

          item.userName = office.userNameEi // 平台编码
          item.passWord = office.passWordEi // 密码
          item.taxpayerId = office.taxPayerIdEi // 纳税人识别号
          item.authorizationCode = office.authorizationCodeEi // 纳税人授权码
          item.wsdlLocation = office.invoiceServiceEi // 电子发票服务请求地址
          item.production = '1' // 1 = 正式使用时通讯用 CA加密
          item.interfaceName = this.properties.interfaceNameEI
          item.email = office.email // 电子邮箱
          // 正式环境报文不需要传password的，置空就可以了 ?!
          if (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_YSHS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE ||
            this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO) {
            if (StrUtils.isEmpty(office.taxPayerIdEi)) {
              this.$message.warning(this.$t('CargoMsg.Cargo_CBTSINNM'))
              return
            }
          } else {
            if (StrUtils.isEmpty(office.userNameEi) || StrUtils.isEmpty(office.taxPayerIdEi) ||
              StrUtils.isEmpty(office.authorizationCodeEi) || StrUtils.isEmpty(office.invoiceServiceEi)) {
              this.$message.warning(this.$t('CargoMsg.Cargo_CBEIPCTSINACSRANMPC'))
              return
            }
            if (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY && StrUtils.isEmpty(office.email)) {
              this.$message.warning(this.$t('CargoMsg.CARGO_OFFICE_EMAIL_ISEMPTY'))
              return
            }
          }
        } else { // 非电子发票
          item.interfaceName = this.properties.interfaceName
          if (this.properties.interfaceName === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceName === InvoiceConstant.INVOICE_HTXX) { // 百旺金穗云 航天信息-诺诺
            if (StrUtils.isEmpty(office.userNameEi) || StrUtils.isEmpty(office.taxPayerIdEi) ||
              StrUtils.isEmpty(office.authorizationCodeEi) || StrUtils.isEmpty(office.invoiceServiceEi)) {
              this.$message.warning(this.$t('CargoMsg.Cargo_CBEIPCTSINACSRANMPC'))
              return
            }
            item.userName = office.userNameEi // 平台编码
            item.passWord = office.passWordEi // 密码
            item.taxpayerId = office.taxPayerIdEi // 纳税人识别号
            item.authorizationCode = office.authorizationCodeEi // 纳税人授权码
            item.wsdlLocation = office.invoiceServiceEi // 电子发票服务请求地址
          }
          if (this.properties.interfaceName === 'BAI_WANG_ORIGIN') {
            if (StrUtils.isEmpty(this.properties.terminalSn)) {
              this.$message.warning(this.$t('CargoMsg.Cargo_ITIOCBNMPCBITIITBCPOTS'))
              return
            }
            item.baiWangOriginTerminalSN = this.properties.terminalSn
          } else if (StrUtils.isEmpty(office.sajtInvoiceService) && this.properties.interfaceName !== InvoiceConstant.INVOICE_TAX_EASY && this.properties.interfaceName !== InvoiceConstant.INVOICE_YSHS && this.properties.interfaceName !== InvoiceConstant.INVOICE_TAX_EASY_THREE &&
                   this.properties.interfaceName !== InvoiceConstant.INVOICE_BWJSY && this.properties.interfaceName !== InvoiceConstant.INVOICE_HTXX) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CBISAWTSNM'))
            return
          }
          if (StrUtils.isEmpty(office.taxAccount)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CBTSINNM'))
            return
          }
        }

        // if (invoice.isDirty) {
        //   this.$message.warning(this.$t('CargoMsg.Cargo_MDEPSBPIN' + invoice.invoiceNo + ']'))
        //   return
        // }
        itemList.push(item)
      }
      // 开票种类(0.纸质发票 1.电子发票)
      if (makeType === '1') {
        if (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_YSHS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE ||
          this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_HTXX || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS) {
          if (exportToGoldenTax) {
            if (this.properties.interfaceName === InvoiceConstant.INVOICE_TAX_EASY_THREE && this.properties.interfaceNameEI !== InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS) {
              this.$confirm(this.$t('CargoMsg.Cargo_RepeatGoldenTaxExport'), this.$t('CargoMsg.Cargo_Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Got_It'),
                showCancelButton: false,
                type: 'warning'
              })
            } else {
              this.$confirm(this.$t('CargoMsg.Cargo_RTGTEOMCACC'), this.$t('CargoMsg.Cargo_Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
                cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
                type: 'warning'
              }).then(() => {
                this.doOutInterfaceExportBatchEi(itemList)
              }).catch(() => {
                //
              })
            }
          } else {
            this.doOutInterfaceExportBatchEi(itemList)
          }
        } else {
          this.doOutInterfaceExportBatchEi(itemList)
        }
      } else {
        if (this.properties.interfaceName === InvoiceConstant.INVOICE_TAX_EASY || this.properties.interfaceName === InvoiceConstant.INVOICE_YSHS || this.properties.interfaceName === InvoiceConstant.INVOICE_TAX_EASY_THREE ||
          this.properties.interfaceName === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceName === InvoiceConstant.INVOICE_HTXX) {
          if (exportToGoldenTax) {
            if (this.properties.interfaceName === InvoiceConstant.INVOICE_TAX_EASY_THREE) {
              this.$confirm(this.$t('CargoMsg.Cargo_RepeatGoldenTaxExport'), this.$t('CargoMsg.Cargo_Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Got_It'),
                showCancelButton: false,
                type: 'warning'
              })
            } else {
              this.$confirm(this.$t('CargoMsg.Cargo_RTGTEOMCACC'), this.$t('CargoMsg.Cargo_Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
                cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
                type: 'warning'
              }).then(() => {
                this.doOutInterfaceExportBatch(itemList)
              }).catch(() => {
                //
              })
            }
          } else {
            this.doOutInterfaceExportBatch(itemList)
          }
        } else {
          this.doOutInterfaceExportBatch(itemList)
        }
      }
    },
    // 电票接口
    doOutInterfaceExportBatchEi(itemList) {
      console.log('doOutInterfaceExportBatchEi', itemList)
      this.loading = getLoading()
      outInterfaceExportBatchEi(itemList, this.location).then(res => {
        console.log('outInterfaceExportBatchEi', res)
        // 刷新
        if (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_YSHS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE ||
          this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_HTXX || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS ||
          this.isNuoNuo || this.isAisinoEi) {
          const selections = getGridSelected(this.gridOptions)
          for (const invoice of selections) {
            if (!invoice.exportToGoldenTax) {
              invoice.exportToGoldenTax = true
            }
          }
          this.refreshGrid()
        }
        //
        this.outInterfaceExportResultHandler(res.data)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 纸票接口
    doOutInterfaceExportBatch(itemList) {
      console.log('doOutInterfaceExportBatch', itemList)
      this.loading = getLoading()
      outInterfaceExportBatch(itemList, this.location).then(res => {
        console.log('outInterfaceExportBatch', res)
        // 刷新
        if (res.data.success && (this.properties.interfaceName === InvoiceConstant.INVOICE_TAX_EASY || this.properties.interfaceName === InvoiceConstant.INVOICE_YSHS || this.properties.interfaceName === InvoiceConstant.INVOICE_TAX_EASY_THREE ||
          this.properties.interfaceName === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceName === InvoiceConstant.INVOICE_HTXX)) {
          const selections = getGridSelected(this.gridOptions)
          for (const invoice of selections) {
            if (!invoice.exportToGoldenTax) {
              invoice.exportToGoldenTax = true
            }
          }
          this.refreshGrid()
        }
        //
        this.outInterfaceExportResultHandler(res.data)
      }).finally(() => {
        this.loading.close()
      })
    },
    outInterfaceExportResultHandler(result) {
      if (result.success) {
        this.$alert(this.$t('CargoMsg.Cargo_ExportedSuccessfully'), this.$t('Message.Success'), {
          confirmButtonText: this.$t('Clearing.Confirm'),
          type: 'success',
          callback: async action => {
            const isYshs = (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_YSHS) || (this.properties.interfaceName === InvoiceConstant.INVOICE_YSHS)
            const isTaxEasyThree = (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE || this.properties.interfaceName === InvoiceConstant.INVOICE_TAX_EASY_THREE)
            const isTaxEasy = (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY || this.properties.interfaceName === InvoiceConstant.INVOICE_TAX_EASY)
            const isTaxEasyThreePlus = this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS
            const isNuoNuo = this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO
            // CARGO-13524，开票/收票页面金税导出发票号显示
            if (isTaxEasy || isYshs || isTaxEasyThree || this.isBwjsy || this.isHtxx || isTaxEasyThreePlus || isNuoNuo || this.isAisinoEi) {
              const keys = []
              const selections = getGridSelected(this.gridOptions)
              for (const invoice of selections) {
                if (isYshs && !invoice.exportToGoldenTax) {
                  this.$message.warning(this.$t('Invoice.NotDoInvoice'))
                  return
                }
                keys.push(invoice.uuid)
              }
              if (keys.length === 0) return
              const obj = { 'keys': keys, 'loadSubDetail': false }
              if (isYshs) {
                obj.interFaceName = InvoiceConstant.INVOICE_YSHS
                obj.officeId = this.$store.getters.currentOfficeId
              }
              this.loading = getLoading()
              if (isYshs) {
                obj.location = this.location
                getInvoiceNos(obj).then(res => {
                  this.refreshInvoice(res, isYshs, selections)
                }).finally(() => {
                  this.loading.close()
                })
              } else {
                getInvoiceDetails(obj).then(res => {
                  this.refreshInvoice(res, isYshs, selections)
                }).finally(() => {
                  this.loading.close()
                })
              }
            }
          }
        })
      } else {
        this.$alert(result.msg, this.$t('CargoMsg.Cargo_OperationFailed'), {
          confirmButtonText: this.$t('Clearing.Confirm'),
          type: 'warning',
          callback: action => {
            //
          }
        })
      }
    },
    // 刷新发票信息
    refreshInvoice(res, isYshs, selections) {
      if (res.data && res.data.length > 0) {
        if (isYshs) {
          this.$message.success(this.$t('Invoice.GetInvoiceNoSuccess'))
        }
        for (const invoice of res.data) {
          for (const item of selections) {
            if (item.uuid === invoice.uuid) {
              // 发票号
              item.invoiceNo = invoice.invoiceNo
              item.invoiceDate = invoice.invoiceDate
              item.webPdfFile = invoice.webPdfFile
              item.isPrinted = invoice.printed
            }
          }
        }
        this.refreshGrid()
      }
    },
    async toApplyPay() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseCheckInvoice'))
        return
      }
      if (this.queryOfficeId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return false
      }
      const charges = await ClearingUtils.createBillPaymentByInvoice(chooseRows, -1)
      if (!(await ClearingUtils.checkCreateBillPaymentByCharges(charges))) return
      if (charges && charges.length > 0) {
        this.showBillPaymentDialog = true
        const initData = { }
        let currency = chooseRows[0].currency
        if (chooseRows.length > 1) {
          for (const charge of chooseRows) {
            if (currency !== charge.currency) {
              currency = ''
              break
            }
          }
        }
        if (currency) {
          initData.currency = currency
        }
        // 校验发票币种是否唯一
        const invoiceCurrency = chooseRows[0]?.currency
        const allSameCurrency = !chooseRows.some(data => data.currency !== invoiceCurrency)

        if (allSameCurrency) {
          const uuids = []
          for (const c of charges) {
            if (c.chargeInvoiceUuid && !uuids.includes(c.chargeInvoiceUuid)) {
              uuids.push(c.chargeInvoiceUuid)
            }
          }

          const invoiceCurrencyMap = {}
          for (const data of chooseRows) {
            if (data.chargeCurrency1 === data.chargeCurrency2 && data.chargeExchangeRate1 === data.chargeExchangeRate2) {
              continue
            }
            if (!uuids.includes(data.uuid)) {
              continue
            }
            if (data.chargeCurrency1 && data.chargeExchangeRate1) {
              let rate = invoiceCurrencyMap[data.chargeCurrency1]
              if (rate && rate !== data.chargeExchangeRate1) {
                rate = NumberUtils.ToFixed2((rate + data.chargeExchangeRate1) / 2, 8)
                invoiceCurrencyMap[data.chargeCurrency1] = rate
              } else {
                invoiceCurrencyMap[data.chargeCurrency1] = data.chargeExchangeRate1
              }
            }
            if (data.chargeCurrency2 && data.chargeExchangeRate2) {
              let rate = invoiceCurrencyMap[data.chargeCurrency2]
              if (rate && rate !== data.chargeExchangeRate2) {
                rate = NumberUtils.ToFixed2((rate + data.chargeExchangeRate2) / 2, 8)
                invoiceCurrencyMap[data.chargeCurrency2] = rate
              } else {
                invoiceCurrencyMap[data.chargeCurrency2] = data.chargeExchangeRate2
              }
            }
          }
          initData.invoiceCurrencyMap = invoiceCurrencyMap
        }
        this.$refs.billPayment.initBillPayment(charges, initData)
      }
    },
    // 付款申请关闭按钮回调事件
    cancelBillPayment() {
      this.showBillPaymentDialog = false
    },
    // 查看
    showInvoiceHandler(event, needChecked = false) {
      if (event && !event.data) {
        return
      }
      console.log('showInvoiceHandler', event)
      if (this.queryOfficeId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckInvoiceQueryBranch'))
        return
      }
      this.invoiceUuid = ''
      if (needChecked) {
        this.properties.selectedEntities = getGridSelected(this.gridOptions)
        if (this.properties.selectedEntities.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        for (const item of this.properties.selectedEntities) {
          if (item.branchId !== this.$store.getters.currentOfficeId && !JobUtils.checkHierarchicalDetailFinancial(item.branchId)) {
            this.$message.warning(this.$t('Message.NoHasViewRole'))
            return
          }
        }
      } else {
        this.invoiceUuid = event.data.uuid
        if (StrUtils.isEmpty(this.invoiceUuid)) {
          return
        }
        if (event.data.branchId !== this.$store.getters.currentOfficeId && !JobUtils.checkHierarchicalDetailFinancial(event.data.branchId)) {
          this.$message.warning(this.$t('Message.NoHasViewRole'))
          return
        }
      }
      // 是否是相同的发票类型
      let type = -1
      for (const invoice of this.properties.selectedEntities) {
        if (type === -1) {
          type = invoice.invoiceType
        }
        if (type !== invoice.invoiceType) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSameInvoiceType'))
          return
        }
      }
      this.viewInvoice(needChecked)
    },
    // 加载发票详情
    async viewInvoice(needChecked = false) {
      const keys = []
      if (needChecked) {
        if (this.properties.selectedEntities.length === 0) {
          return
        }
        for (const item of this.properties.selectedEntities) {
          keys.push(item.uuid)
        }
      } else {
        if (StrUtils.isEmpty(this.invoiceUuid)) {
          return
        }
        keys.push(this.invoiceUuid)
      }
      if (keys.length === 0) return
      const requestBody = { 'keys': keys }
      console.log('keys', requestBody)
      this.loading = getLoading()
      await getInvoiceDetails(requestBody).then(res => {
        console.log('getInvoiceDetails', res)
        this.properties.invoices = res.data
      }).finally(() => {
        this.loading.close()
      })
      this.properties.currentPage = 1
      this.pageChange('viewInvoice')
      this.step = 'step3'
    },
    // 切换发票
    pageChange(data) {
      console.log('pageChange:', data)
      //
      this.properties.totalPage = this.properties.invoices.length
      if (this.properties.currentPage > this.properties.totalPage) { this.properties.currentPage = this.properties.totalPage }
      if (this.properties.currentPage < 1) { this.properties.currentPage = 1 }
      //
      if (this.properties.totalPage > 0) {
        this.properties.invoice = this.properties.invoices[this.properties.currentPage - 1]
        // 增票合并/显示明细
        if (this.properties.invoice.ar && [2, 3, 6, 7].includes(this.properties.invoice.invoiceType)) {
          this.properties.rbgShowChargeDetail = 'merge'
          for (const invoiceItem of this.properties.invoice.invoiceItemList) {
            if (invoiceItem.goodsName.indexOf('\n') > -1) {
              this.properties.rbgShowChargeDetail = 'detail'
            }
          }
        } else if (this.properties.invoice.ar && [0, 1, 4].includes(this.properties.invoice.invoiceType)) {
          this.properties.rbgShowChargeDetail = 'merge'
          if (!StrUtils.isEmpty(this.properties.invoice.partAmount) && this.properties.invoice.partAmount.indexOf('\n') > -1) {
            this.properties.rbgShowChargeDetail = 'detail'
          }
        }
        console.log('invoice', this.properties.invoice)
        //
        this.$refs.makeInvoiceDialog.initBaseData()
      }
    },
    // 退出详情
    toStepHandler(data) {
      this.step = data
      console.log('step:', this.step)
    },
    // 保存发票后刷新
    saveSuccess(invoices) {
      console.log('saveSuccess', invoices)
      let update = false
      const invoiceList = StrUtils.isEmpty(this.invoiceUuid) ? this.properties.selectedEntities : this.rowData
      for (const invoice of invoices) {
        for (const item of invoiceList) {
          if (item.uuid === invoice.uuid) {
            update = true
            // 发票号
            item.invoiceNo = invoice.invoiceNo
            item.title = invoice.title
            item.auditor = invoice.auditor
            item.invoiceDate = invoice.invoiceDate
            item.amount = invoice.amount
            item.taxAmount = invoice.taxAmount
            item.excludingTaxAmount = invoice.excludingTaxAmount
            item.sellTitle = invoice.sellTitle
            item.vesselVoyage = invoice.vesselVoyage
            item.remark = invoice.remark
            item.remark2 = invoice.remark2
            item.webPdfFile = invoice.webPdfFile
            if (invoice.isPrinted) {
              item.isPrinted = invoice.isPrinted
            }
            item.paymentTerm = invoice.paymentTerm
            item.incomePayDate = invoice.incomePayDate
          }
        }
      }
      if (update) {
        this.refreshGrid()
      }
    },
    printHandler() {
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return
      }
      const params = {}
      const uids = []
      for (const invoice of selections) {
        // CARGO-34409 取消开票模块的打印限制
        // if (invoice.invoiceState !== InvoiceConstant.OFFSET_NORMAL.code) {
        //   this.$message.warning(this.$t('CargoMsg.Cargo_OIWWBCBP'))
        //   return
        // }
        uids.push(invoice.uuid)
      }
      params.INVOICE_UUID_LIST = uids
      params.INVOICE_UUID = uids
      params.printSource = DocumentConstants.BATCH_PRINT_FP.code
      params.USER_UUID = this.$store.getters.userInfo.userId
      params.classNameType = SystemConstants.ACT
      // TemplateSelectorWin.getInstance().showThisWin(selections.getItemAt(0) as AbstractEntity, "INVOICELIST", params, this);
      this.templateSelectorDialog.cxt = new Invoice(selections[0])
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.category = 'INVOICELIST'
      this.templateSelectorDialog.visible = true
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCount() {
      console.log('toRefreshSelectedCount')
      this.filterChanged()
      // this.once.excute(this.refreshSelectedCount, [], 200)
    },
    filterChanged() {
      const selections = getGridSelected(this.gridOptions)
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCount, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (!node.data) {
              return
            }
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length == this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [], 200)
            }
            if (hasDisplay.length < this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
            }
          } else {
            this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCount(arg, selections) {
      if (arg == 0) {
        this.totalAmountToCurrency.dataProvider = selections
        this.totalAmountToCurrency.selectedCount = selections.length
      } else if (arg == 1) {
        this.totalAmountToCurrency.dataProvider = selections
        this.totalAmountToCurrency.selectedCount = 0
      } else {
        this.totalAmountToCurrency.dataProvider = this.rowData
        this.totalAmountToCurrency.selectedCount = 0
      }
    },
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.queryInvoice')
        const footer = document.getElementById('footer-wrapper')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        if (offset > containerHeight) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    // 下载电子发票
    downElectronicInvoiceHandler(invoice) {
      console.log('downElectronicInvoiceHandler', invoice)
      if (StrUtils.isEmpty(invoice.invoiceNo)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoElectronicInvoiceNoToCreate'))
        return
      }
      if (StrUtils.isEmpty(invoice.webPdfFile)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PCITIHBI'))
        return
      } else if (invoice.webPdfFile === 'pdfFile') {
        checkInvoiceExistfFile({ invoiceUuid: invoice.uuid }).then(res => {
          if (res.data) {
            const url = URL.act.invoice.downInvoiceWebPdfFile + '?sessionId=' + getToken() + '&invoiceUuid=' + invoice.uuid
            window.open(url)
            this.addDownloadLogHandler(invoice, 'PDF', url)
          } else {
            this.$message.warning(this.$t('CargoMsg.Cargo_INVOICE_NO_FILE'))
          }
        })
      } else {
        const url = URL.common.findByFileId + '/' + invoice.webPdfFile + '?sessionId=' + getToken()
        window.open(url)
        this.addDownloadLogHandler(invoice, 'PDF', url)
      }
    },
    // 发送邮件
    clickSendMailHandler(invoice) {
      console.log('clickSendMailHandler', invoice)
      if (StrUtils.isEmpty(invoice.invoiceNo)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoElectronicInvoiceNoToCreate'))
        return
      }
      if (!StrUtils.isEmpty(invoice.uuid)) {
        this.emailEnterTitleWindow.invoiceKey = invoice.uuid
        this.emailEnterTitleWindow.accountId = invoice.accountId
        this.emailEnterTitleWindow.visible = true
      }
    },
    // 查看发送邮件日志
    clickMailLogHandler(invoice) {
      if (!StrUtils.isEmpty(invoice.uuid)) {
        this.emailLogTitleWindow.invoiceKey = invoice.uuid
        this.emailLogTitleWindow.visible = true
      }
    },
    async fetchStaticTitleList() {
      try {
        const officeId = this.$store.getters.currentOfficeId
        const res = await getInvoiceTitlesByOffice({ officeId })
        const list = res && Array.isArray(res.data) ? res.data : []
        return list
      } catch (e) {
        return []
      }
    },
    // 自定义高级查询
    async initCustomSearchItems() {
      const res = await getBankAccountList(this.$store.getters.currentOfficeUuid)
      const titleList = await this.fetchStaticTitleList()
      // 银行名称和银行账号要去重
      const bankList = []
      const bankNoList = []
      if (res.data && res.data.length > 0) {
        for (const item of res.data) {
          const bank = item.bankChineseName
          const bankNo = item.accountNo
          if (bankList.length === 0) {
            bankList.push(item)
          } else {
            const index = bankList.findIndex(p => p.bankChineseName === bank)
            if (index < 0) {
              bankList.push(item)
            }
          }
          if (bankNoList.length === 0) {
            bankNoList.push(item)
          } else {
            const index = bankNoList.findIndex(p => p.accountNo === bankNo)
            if (index < 0) {
              bankNoList.push(item)
            }
          }
        }
      }
      const defaultSearchItems = []
      // 我方银行名称
      let searchField = new AdvancedSearchField()
      searchField.itemType = 'advanceSelect'
      searchField.multiple = 0
      searchField.action = 2
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemValue = []
      searchField.itemLabel = 'Invoice.invoice_sp8'
      searchField.itemName = 'invoice.BANK'
      searchField.headers = [this.$t('Clearing.BankName')]
      searchField.fields = ['bankChineseName']
      searchField.tagName = 'bankChineseName'
      searchField.tagValue = 'bankChineseName'
      searchField.dataCacheKey = 'static_data_BankAccount'
      searchField.dataProvider = bankList
      defaultSearchItems.push(searchField.formatObj2Json())
      // 我方银行账号
      const bankAccountNoSearchField = new AdvancedSearchField()
      bankAccountNoSearchField.itemType = 'advanceSelect'
      bankAccountNoSearchField.multiple = 0
      bankAccountNoSearchField.action = 2
      bankAccountNoSearchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      bankAccountNoSearchField.itemValue = []
      bankAccountNoSearchField.itemLabel = 'Invoice.OurBankAccountNo'
      bankAccountNoSearchField.itemName = 'invoice.BANKACCOUNT'
      bankAccountNoSearchField.headers = [this.$t('Clearing.BankAccountNumber')]
      bankAccountNoSearchField.fields = ['accountNo']
      bankAccountNoSearchField.tagName = 'accountNo'
      bankAccountNoSearchField.tagValue = 'accountNo'
      bankAccountNoSearchField.dataCacheKey = 'static_data_BankAccount'
      bankAccountNoSearchField.dataProvider = bankNoList
      defaultSearchItems.push(bankAccountNoSearchField.formatObj2Json())

      // 销户单位（数据源：发票抬头 / officeInvoiceTitle.getListByOffice）
      const closeAccountCompanyField = new AdvancedSearchField()
      closeAccountCompanyField.itemType = 'advanceSelect'
      closeAccountCompanyField.dataCacheKey = 'static_data_InvoiceTitle'
      closeAccountCompanyField.multiple = 0
      closeAccountCompanyField.action = 2
      closeAccountCompanyField.fieldType = 'FIELD_DROP_DOWN_LIST'
      closeAccountCompanyField.itemValue = []
      closeAccountCompanyField.itemLabel = 'Invoice.closeAccountCompany'
      closeAccountCompanyField.itemName = 'invoice.SELL_TITLE'
      closeAccountCompanyField.headers = [this.$t('Invoice.invoice_invoiceHeader')]
      closeAccountCompanyField.fields = ['invoiceTitle']
      closeAccountCompanyField.tagName = 'invoiceTitle'
      closeAccountCompanyField.tagValue = 'invoiceTitle'
      closeAccountCompanyField.dataProvider = titleList
      defaultSearchItems.push(closeAccountCompanyField.formatObj2Json())

      if (this.useOrderCenterMode) {
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
        let searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        defaultSearchItems.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        defaultSearchItems.push(searchField.formatObj2Json())
      }
      if (this.isFei) { // 支持全电的发票类型走这里
        let feiField = new AdvancedSearchField()
        feiField.itemType = 'select'
        feiField.multiple = 1
        feiField.action = AdvancedSearchField.UPDATE_ACTION
        feiField.itemCondition = []
        feiField.defaultConditionVal = ''
        feiField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        feiField.itemValue = []
        feiField.itemLabel = 'Invoice.invoice_invoiceType'
        feiField.itemName = 'invoice.INVOICE_TYPE'
        feiField.defaultSelected = 0
        feiField.selected = 0
        feiField.dropdownDataRef = 'InvoiceConstant.INVOICE_TYPES_FEI'
        feiField.dataCacheKey = 'local_cache_InvoiceConstant$INVOICE_TYPES_FEI'
        feiField.valueExpression = ''
        feiField.lock = false
        feiField.defaultValue = []
        defaultSearchItems.push(feiField.formatObj2Json())

        // 红字申请状态
        // feiField = new AdvancedSearchField()
        // feiField.itemType = 'select'
        // feiField.multiple = 1
        // feiField.action = AdvancedSearchField.ADD_ACTION
        // feiField.itemCondition = []
        // feiField.defaultConditionVal = ''
        // feiField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        // feiField.itemValue = []
        // feiField.itemLabel = 'Invoice.FeiRedApplicationStatus'
        // feiField.itemName = 'invoice.RED_OFFSET_STATE'
        // feiField.defaultSelected = 0
        // feiField.selected = 0
        // feiField.dropdownDataRef = 'InvoiceConstant.RED_OFFSET_STATUS'
        // feiField.dataCacheKey = 'local_cache_InvoiceConstant$RED_OFFSET_STATUS'
        // feiField.valueExpression = ''
        // feiField.lock = false
        // feiField.defaultValue = []
        // this.customSearchItems.push(feiField.formatObj2Json())

        // 红冲原因
        feiField = new AdvancedSearchField()
        feiField.itemType = 'select'
        feiField.multiple = 0
        feiField.action = AdvancedSearchField.ADD_ACTION
        feiField.itemCondition = []
        feiField.defaultConditionVal = ''
        feiField.fieldType = 'FIELD_DROP_DOWN_LIST'
        feiField.itemValue = []
        feiField.itemLabel = 'Invoice.RedFlushReason'
        feiField.itemName = 'invoice.RED_OFFSET_REASON'
        feiField.defaultSelected = 0
        feiField.selected = 0
        feiField.dropdownDataRef = 'InvoiceConstant.INVOICE_TYPES_FEI'
        if (this.customizeRevokeInvoiceAutoCharge === 2) {
          if (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS) {
            feiField.dataCacheKey = 'local_cache_InvoiceConstant$RED_OFFSET_REASON_ALL'
          } else {
            feiField.dataCacheKey = 'local_cache_InvoiceConstant$RED_OFFSET_REASONS_NEW'
          }
        } else {
          feiField.dataCacheKey = 'local_cache_InvoiceConstant$RED_OFFSET_REASONS'
        }
        feiField.valueExpression = ''
        feiField.lock = false
        feiField.defaultValue = []
        defaultSearchItems.push(feiField.formatObj2Json())
      }
      if (this.isBpmEnabled) {
        // CARGO-39771 BPM各审批流增加快捷入口（增加审批流水号）
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'input'
        searchField.operationType = 'text6'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemName = 'approvalForm.DOCUMENT_PROCESS_NO'
        searchField.itemLabel = 'CargoMsg.Cargo_ApprovalSerialNumber'
        searchField.itemValue = ''
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.lock = false
        searchField.defaultValue = ''
        searchField.action = AdvancedSearchField.ADD_ACTION
        defaultSearchItems.push(searchField.formatObj2Json())
      }
      if (this.hmToFinanceApi) {
        // 同步云平台状态
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = AdvancedSearchConsts.OPERATOR_IN.code
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'invoice._hmPushExternalInterfaceStatus_'
        searchField.itemLabel = 'Clearing.SyncCloudPlatformStatus'
        searchField.defaultValue = []
        searchField.dataProvider = ChargeConstants.HM_YONGYOU_SYNC_STATUS
        searchField.action = AdvancedSearchField.ADD_ACTION
        defaultSearchItems.push(searchField.formatObj2Json())
      } else {
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'invoice._hmPushExternalInterfaceStatus_'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchItems.push(searchField.formatObj2Json())
      }

      if (this.qlToFinanceApi) {
        // 同步云平台状态
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = AdvancedSearchConsts.OPERATOR_IN.code
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'invoice._qlPushExternalInterfaceStatus_'
        searchField.itemLabel = 'Clearing.SyncCloudPlatformStatus'
        searchField.defaultValue = []
        searchField.dataProvider = ChargeConstants.QL_KD_SYNC_STATUS
        searchField.action = AdvancedSearchField.ADD_ACTION
        defaultSearchItems.push(searchField.formatObj2Json())
      } else {
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'invoice._qlPushExternalInterfaceStatus_'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchItems.push(searchField.formatObj2Json())
      }

      if (this.jydToFinanceApi) {
        // 云平台状态
        searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [OPERATOR_IN]
        searchField.defaultConditionVal = OPERATOR_IN.code
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'invoicePushRecord.SEND_STATUS'
        searchField.itemLabel = 'CargoMsg.Cargo_CloudPlatformSyncStatus'
        searchField.defaultValue = []
        searchField.dataProvider = ChargeConstants.HM_YONGYOU_SYNC_STATUS
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        defaultSearchItems.push(searchField.formatObj2Json())
      }

      // 发票性质/税率标识
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN, AdvancedSearchConsts.OPERATOR_NOT_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'invoice.INVOICE_NATURE'
      searchField.itemLabel = 'CargoMsg.Cargo_InvoiceNature'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = InvoiceConstant.INVOICE_NATURE
      defaultSearchItems.push(searchField.formatObj2Json())

      if (this.$checkPermission(['role_ViewHierarchicalListAtFinancial']) || this.$checkPermission(['role_ViewHierarchicalDetailAtFinancial'])) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItems, defaultSearchItems)
      }
      this.customSearchItems = defaultSearchItems
    },
    updateSuccessHandler(event) {
      let update = false
      if (event.invoiceList && event.invoiceList.length > 0) {
        const invoiceList = this.rowData
        for (const invoice of invoiceList) {
          for (const key of event.invoiceList) {
            if (invoice.uuid === key) {
              invoice.invoiceType = event.invoiceType
              invoice.makeType = event.makeType
              update = true
            }
          }
        }
      }
      if (update) {
        this.refreshGrid()
      }
    },
    sendEmailSuccessHandler(invoiceUuid) {
      for (const row of this.rowData) {
        if (row.uuid === invoiceUuid) {
          row.sendEmailStatus = 1
          break
        }
      }
      this.refreshGrid()
    },
    async updateInvoiceHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      let e = false
      const keyList = []
      for (const invoice of rows) {
        // 已核销/已金税导出/已复核/已作废/红冲/已出凭证
        if (invoice.realClearingState !== 0 || invoice.exportToInterface || invoice.voucherDate2Charge || invoice.isPrinted ||
            invoice.isReview || invoice.isRevoked || invoice.invoiceState !== 0 || invoice.targetVoucherNo2Charge || (!!invoice.approvalStatus && invoice.approvalStatus !== BPM_STATES_UN_APPROVED.code)) {
          e = true
          break
        }
        keyList.push(invoice.uuid)
      }
      if (e) {
        this.$message.warning(this.$t('Message.ContainsInvoicesThatCannotBeModified'))
        return
      }
      this.updateInvoice.visible = true
      this.updateInvoice.invoiceList = keyList
    },
    // 批量下载电子发票
    async batchDownloadElectronicInvoice() {
      const rows = this.gridOptions.api.getSelectedRows()
      // 判断是否有权限
      if (!await this.validate(rows)) {
        return
      }
      if (rows.length > 0) {
        // const fileIds = Array.from(rows.filter(row => !!row.fileId), p => p.fileId).reduce((a, b) => a + ',' + b)
        // const day = moment().format('YYYYMMDDHHmmss')
        // const fileName = 'invoice' + day + '.zip'
        // window.open(`${URL.common.compressFiles}?sessionId=${this.$store.getters.userInfo.sessionId}&fileIds=${fileIds}&compressFileName=${fileName}`)
        const fileIds = []
        const fileNames = []
        for (const row of rows) {
          if (!row.fileId) {
            continue
          }
          fileIds.push(row.fileId)
          fileNames.push(`inv${row.invoiceNo}${row.title}`)
        }
        submitDataByPost(URL.common.compressWithFileNames, {
          sessionId: this.$store.getters.userInfo.sessionId,
          fileIds: fileIds.join(','),
          fileNames: fileNames.join(','),
          compressFileName: 'invoice' + moment().format('YYYYMMDDHHmmss') + '.zip'
        })
      }
    },
    async validate(rows) {
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return false
      }
      // 1）判断勾选的发票是否存在纸质发票，存在纸质发票，提示：仅支持批量下载电子发票，请检查发票种类。点击“确定”，返回上一界面。
      const existPaper = rows.find(row => row.makeType === InvoiceConstant.MAKE_TYPE_PAPER.code)
      if (existPaper) {
        await this.$confirm(this.$t('Clearing.OnlyElectronicInvoicesPleaseType'), this.$t('Message.Confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          showCancelButton: false,
          closeOnClickModal: false,
          type: 'warning'
        })
        return false
      }
      // 2）判断勾选的发票是否有回传已生成的电子发票的附件？在点击【批量下载电子发票】时出现提示：共勾选x条，可下载y条，是否确认下载。点击“确定”，开始下载。点击“取消”，返回上一界面。
      const existFileInvoice = rows.filter(row => !!row.webPdfFile)
      return await this.$confirm(this.$t('Clearing.TotalSelection') + rows.length + this.$t('Clearing.N0ItemsDownloadable') + existFileInvoice.length + this.$t('Clearing.N0ItemsConfirmDownload'), this.$t('Message.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        for (const el of existFileInvoice) {
          el.fileId = el.webPdfFile
        }
        return existFileInvoice.length > 0
      })
    },
    // 获取发票号
    async getInvoiceInfo() {
      const allowTaxOperation = await BSWarningUtil.checkTaxExpire()
      if (!allowTaxOperation) {
        return
      }
      const keys = []
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return
      }
      for (const invoice of selections) {
        if (!invoice.exportToGoldenTax) {
          this.$message.warning(this.$t('Invoice.NotDoInvoice'))
          return
        }
        keys.push(invoice.uuid)
      }
      if (keys.length === 0) return
      this.loading = getLoading()
      const obj = { 'keys': keys, 'loadSubDetail': false }
      obj.interFaceName = InvoiceConstant.INVOICE_YSHS
      obj.officeId = this.$store.getters.currentOfficeId
      obj.location = this.location
      getInvoiceNos(obj).then(res => {
        if (res.data && res.data.length > 0) {
          this.$message.success(this.$t('Invoice.GetInvoiceNoSuccess'))
          for (const invoice of res.data) {
            for (const item of selections) {
              if (item.uuid === invoice.uuid) {
                // 发票号
                item.invoiceNo = invoice.invoiceNo
                item.invoiceDate = invoice.invoiceDate
                item.webPdfFile = invoice.webPdfFile
                item.isPrinted = invoice.printed
              }
            }
          }
          this.refreshGrid()
        } else {
          this.$message.error(this.$t('Invoice.GetInvoiceNoFail'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    },
    // 获取发票号
    async getInvoiceNoByBwjsy() {
      const allowTaxOperation = await BSWarningUtil.checkTaxExpire()
      if (!allowTaxOperation) {
        return
      }
      if (this.properties.QdWarning) {
        this.$confirm(this.$t('Invoice.QdWarningTip'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          showCancelButton: false,
          closeOnClickModal: false,
          type: 'warning'
        })
        return
      }
      const keys = []
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return
      }
      for (const invoice of selections) {
        if (!invoice.exportToGoldenTax) {
          this.$message.warning(this.$t('Invoice.NotDoInvoiceBwjsy'))
          return
        }
        // 全电验证
        if (invoice.invoiceNo && (invoice.invoiceType === InvoiceConstant.INVOICE_TYPE_VAT_FEI.code || invoice.invoiceType === InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code)) {
          continue
        }
        keys.push(invoice.uuid)
      }
      if (keys.length === 0) {
        this.$message.warning(this.$t('Invoice.SelectRightInvoice'))
        return
      }
      const office = this.$store.getters.currentOffice
      if (StrUtils.isEmpty(office.userNameEi) || StrUtils.isEmpty(office.taxPayerIdEi) ||
        StrUtils.isEmpty(office.authorizationCodeEi) || StrUtils.isEmpty(office.invoiceServiceEi)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CBEIPCTSINACSRANMPC'))
        return
      }
      this.loading = getLoading()
      const obj = { 'keys': keys, 'loadSubDetail': false }
      obj.officeId = this.$store.getters.currentOfficeId
      obj.userName = office.userNameEi // 平台编码
      obj.passWord = office.passWordEi // 密码
      obj.taxpayerId = office.taxPayerIdEi // 纳税人识别号
      obj.authorizationCode = office.authorizationCodeEi // 纳税人授权码
      obj.wsdlLocation = office.invoiceServiceEi // 电子发票服务请求地址
      obj.location = this.location
      getInvoiceNoByBwjsy(obj).then(res => {
        if (res.data && res.data.length > 0) {
          let success = false
          let fail = false
          for (const item of selections) {
            for (const invoice of res.data) {
              if (item.uuid === invoice.uuid) {
                // 发票号
                item.invoiceNo = invoice.invoiceNo
                item.invoiceDate = invoice.invoiceDate
                item.webPdfFile = invoice.webPdfFile
                item.isPrinted = invoice.printed
              }
            }
            if (StrUtils.isEmpty(item.invoiceNo)) fail = true
            if (!StrUtils.isEmpty(item.invoiceNo)) success = true
          }
          if (success && !fail) {
            this.$message.success(this.$t('Invoice.GetInvoiceNoSuccessBwjsy'))
          } else if (!success && fail) {
            this.$message.error(this.$t('Invoice.GetInvoiceNoFail'))
          } else if (success && fail) {
            this.$message.warning(this.$t('Invoice.GetInvoiceNoFailPart'))
          }
          this.refreshGrid()
        } else {
          this.$message.error(this.$t('Invoice.GetInvoiceNoFail'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 获取发票号-航天信息-诺诺
    async getInvoiceNoByHtxx() {
      const allowTaxOperation = await BSWarningUtil.checkTaxExpire()
      if (!allowTaxOperation) {
        return
      }
      const office = this.$store.getters.currentOffice
      if (StrUtils.isEmpty(office.userNameEi) || StrUtils.isEmpty(office.taxPayerIdEi) ||
        StrUtils.isEmpty(office.authorizationCodeEi) || StrUtils.isEmpty(office.invoiceServiceEi)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CBEIPCTSINACSRANMPC'))
        return
      }
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return
      }
      const keys = []
      for (const invoice of selections) {
        keys.push(invoice.uuid)
      }
      if (keys.length === 0) {
        return
      }
      const entities = await getInvoiceDetails({ 'keys': keys, 'loadSubDetail': false }).then(res => res.data)
      const finalKeys = []
      if (entities && entities.length > 0) {
        for (const invoice of entities) {
          if (!invoice.exportToGoldenTax) {
            this.$message.warning(this.$t('Invoice.NotInvoice'))
            return
          }
          if (invoice.invoiceNo) {
            return
          }
          finalKeys.push(invoice.uuid)
        }
      }
      if (finalKeys.length === 0) {
        return
      }
      this.loading = getLoading()
      const obj = { 'keys': finalKeys, 'loadSubDetail': false }
      obj.officeId = this.$store.getters.currentOfficeId
      obj.userName = office.userNameEi // 平台编码
      obj.passWord = office.passWordEi // 密码
      obj.taxpayerId = office.taxPayerIdEi // 纳税人识别号
      obj.authorizationCode = office.authorizationCodeEi // 纳税人授权码
      obj.wsdlLocation = office.invoiceServiceEi // 电子发票服务请求地址
      obj.location = this.location
      getInvoiceNoByHtxx(obj).then(res => {
        // 这里返回的都是成功的数据
        if (res.data && res.data.length > 0) {
          let success = false
          let fail = false
          for (const item of selections) {
            for (const invoice of res.data) {
              if (item.uuid === invoice.uuid) {
                // 发票号
                item.invoiceNo = invoice.invoiceNo
                item.invoiceDate = invoice.invoiceDate
                item.webPdfFile = invoice.webPdfFile
                item.isPrinted = invoice.printed
              }
            }
            if (StrUtils.isEmpty(item.invoiceNo)) fail = true
            if (!StrUtils.isEmpty(item.invoiceNo)) success = true
          }
          if (success && !fail) {
            this.$message.success(this.$t('Invoice.GetInvoiceNoSuccessBwjsy'))
          } else if (!success && fail) {
            this.$message.error(this.$t('Invoice.GetInvoiceNoFail'))
          } else if (success && fail) {
            this.$message.warning(this.$t('Invoice.GetInvoiceNoFailPart'))
          }
          this.refreshGrid()
        } else {
          this.$message.error(this.$t('Invoice.GetInvoiceNoFail'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 容津3.0纸质发票打印
    taxEasyThreePaperPrint() {
      const keys = []
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return
      }
      for (const invoice of selections) {
        if (!invoice.returnTaxCode) {
          this.$message.warning(this.$t('Invoice.NotInvoice'))
          return
        }
        keys.push(invoice.uuid)
      }
      const loading = getLoading4Cxt()
      getTaxEasyThreePaperPrintUrl(keys).then(res => {
        let url = res.data
        if (location.href.startsWith('https:')) {
          if (url.startsWith('http:')) {
            url = url.replace('http:', 'https:')
          }
        } else if (location.href.startsWith('http:')) {
          if (url.startsWith('https:')) {
            url = url.replace('https:', 'http:')
          }
        }
        this.taxEasyThreePrintDialog.url = url
        this.taxEasyThreePrintDialog.visible = true
      }).finally(() => {
        loading.close()
      })
    },
    // 发票号导入
    importVATHandler(file) {
      const loading = getLoading4Cxt(this)
      importInvoiceQd({ file: file.raw, branchId: this.$store.getters.currentOfficeId, location: this.location }).then(res => {
        const message = res.data.message
        if (message) {
          this.$message.error(message)
          return
        }
        const { successCount, failCount, fileId } = res.data
        this.$confirm(message || this.$t('Pricing.XSuccessfulXFailed', [successCount, failCount]), this.$t('SeaExport.ImportComplete'), {
          cancelButtonText: this.$t('Partners.downloadImportResults'),
          confirmButtonText: this.$t('Message.Confirm'),
          distinguishCancelAndClose: true,
          beforeClose: async(action, instance, done) => {
            if (action === 'cancel') {
              if (!fileId) {
                // 若文件ID不存在则提示结果文件上传云储存失败
                this.$message.error(this.$t('Message.ResultLogUploadFaild'))
                done()
              } else {
                // const storageUrl = cache.config.get('StorageURL')
                const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.$store.getters.token}`
                const el = document.createElement('a')
                document.body.appendChild(el)
                el.href = url
                el.target = '_blank'
                el.click()
                document.body.removeChild(el)
              }
            } else {
              done()
              this.toQueryInvoiceList()
            }
          }
        })
      }).finally(() => {
        loading.close()
      })
    },
    importInvoiceDataHandler(file) {
      const loading = getLoading4Cxt(this)
      let importFunc = importInvoiceDataFunc
      if (this.properties.toExoSystemOJ) {
        importFunc = importInvoiceDataOJFunc
      }
      importFunc({ file: file.raw, branchId: this.$store.getters.currentOfficeId, location: this.location }).then(res => {
        const message = res.data.message
        if (message) {
          this.$message.error(message)
          return
        }
        const { successCount, failCount, fileId } = res.data
        this.$confirm(message || this.$t('Pricing.XSuccessfulXFailed', [successCount, failCount]), this.$t('SeaExport.ImportComplete'), {
          cancelButtonText: this.$t('Partners.downloadImportResults'),
          confirmButtonText: this.$t('Message.Confirm'),
          distinguishCancelAndClose: true,
          beforeClose: async(action, instance, done) => {
            if (action === 'cancel') {
              if (!fileId) {
                // 若文件ID不存在则提示结果文件上传云储存失败
                this.$message.error(this.$t('Message.ResultLogUploadFaild'))
                done()
              } else {
                // const storageUrl = cache.config.get('StorageURL')
                const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.$store.getters.token}`
                const el = document.createElement('a')
                document.body.appendChild(el)
                el.href = url
                el.target = '_blank'
                el.click()
                document.body.removeChild(el)
              }
            } else {
              done()
              this.toQueryInvoiceList()
            }
          }
        })
      }).finally(() => {
        loading.close()
      })
    },
    // 6.4.2.红字申请结果查询
    searchRedResult() {
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return
      }
      const applyKeys = []
      for (const selection of selections) {
        // 过滤掉非红冲的
        if (selection.invoiceState !== Number(InvoiceConstant.OFFSET_RED_PUNCH.code) || selection.exportToGoldenTax) {
          continue
        }
        applyKeys.push(selection.uuid)
      }
      if (applyKeys.length === 0) {
        this.$message.warning(this.$t('Invoice.SelectRightInvoice'))
        return
      }
      if (applyKeys.length === 0) return
      this.loading = getLoading()
      const obj = { 'keys': applyKeys, 'loadSubDetail': false }
      obj.officeId = this.$store.getters.currentOfficeId
      searchRedResult(obj).then(res => {
        if (res.data) {
          this.toQueryInvoiceList()
          this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
        } else {
          this.$message.error(this.$t('CargoMsg.Cargo_OperatedFailed'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 开启QdWarning后，所有全电接口不能用
    getQdWarning() {
      if (this.properties.QdWarning) {
        this.$confirm(this.$t('Invoice.QdWarningTip'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          showCancelButton: false,
          closeOnClickModal: false,
          type: 'warning'
        })
        return true
      }
      return false
    },
    // 红字申请
    redApplyHandler() {
      if (this.getQdWarning()) {
        return
      }
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return
      }
      const invoiceKeys = []
      for (const invoice of selections) {
        // 只支持全电类型的发票
        if (invoice.invoiceType !== InvoiceConstant.INVOICE_TYPE_VAT_FEI.code && invoice.invoiceType !== InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code) {
          this.$message.warning(this.$t('Invoice.BatchCheckRedFlushInvoiceType'))
          return
        }
        // 红字未申请或者申请失败，能重新进行申请
        // if (invoice.redOffsetState !== Number(InvoiceConstant.RED_OFFSET_STATUS_NOT_APPLIED.code) && invoice.redOffsetState !== Number(InvoiceConstant.RED_OFFSET_STATUS_FAIL.code)) {
        //   this.$message.warning(this.$t('Invoice.BatchCheckNotRedApplyInvoice'))
        //   return
        // }
        // 只支持红冲状态的发票
        if (!invoice.isRevoked || invoice.invoiceState !== Number(InvoiceConstant.OFFSET_RED_PUNCH.code)) { // 0未红冲 1被红冲 2红冲
          this.$message.warning(this.$t('Invoice.BatchCheckNotRedStatus'))
          return
        }
        invoiceKeys.push(invoice.uuid)
      }
      const loading = getLoading4Cxt()
      const obj = { 'keys': invoiceKeys, 'branchId': this.$store.getters.currentOfficeId }
      redApply(obj).then(res => {
        const result = res.data
        if (result.success) {
          this.$alert(this.$t('CargoMsg.Cargo_OperationSuccessfully'), this.$t('Message.Success'), {
            confirmButtonText: this.$t('Clearing.Confirm'),
            type: 'success',
            callback: action => {
              this.toQueryInvoiceList()
            }
          })
        } else {
          this.$alert(result.msg, this.$t('CargoMsg.Cargo_OperationFailed'), {
            confirmButtonText: this.$t('Clearing.Confirm'),
            type: 'warning',
            callback: action => {
              //
            }
          })
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 红字申请撤销
    rollBackRedPunchHandler() {
      // if (this.properties.QdWarning) {
      //   this.$confirm(this.$t('Invoice.QdWarningTip'), this.$t('common.tips.prompt'), {
      //     confirmButtonText: this.$t('common.btn.ok'),
      //     showCancelButton: false,
      //     closeOnClickModal: false,
      //     type: 'warning'
      //   })
      //   return
      // }
      // const selections = getGridSelected(this.gridOptions)
      // if (selections.length === 0) {
      //   this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
      //   return
      // }
      // const applyKeys = []
      // const applyRollbackKeys = []
      // // 当选择的发票 红冲状态=红冲 且 全电红字申请状态=成功 或 撤销中   导出状态=未导出 时方可点击操作，其余状态发票均置灰处理。
      // // 全电红字申请状态=成功  触发红字撤销申请接口
      // // 全电红字申请状态=撤销中  触发红字撤销申请查询接口
      // for (const selection of selections) {
      //   // 过滤掉非红冲的
      //   if (selection.invoiceState !== Number(InvoiceConstant.OFFSET_RED_PUNCH.code) || selection.exportToGoldenTax) {
      //     continue
      //   }
      //   // 红字撤销申请接口
      //   if (selection.redOffsetState === Number(InvoiceConstant.RED_OFFSET_STATUS_SUCCESS.code)) {
      //     applyKeys.push(selection.uuid)
      //   }
      //   // 红字撤销申请查询接口
      //   if (selection.redOffsetState === Number(InvoiceConstant.RED_OFFSET_STATUS_IN_REVOCATION.code)) {
      //     applyRollbackKeys.push(selection.uuid)
      //   }
      // }
      // if (applyKeys.length === 0 && applyRollbackKeys.length === 0) {
      //   this.$message.warning(this.$t('Invoice.SelectRightInvoice'))
      //   return
      // }
      // if (applyKeys.length !== selections.length && applyRollbackKeys.length !== selections.length) {
      //   this.$message.warning(this.$t('Invoice.BatchCheckRedFlushInvoice'))
      //   return
      // }
      // const loading = getLoading4Cxt()
      // const obj = { 'applyKeys': applyKeys, 'applyRollbackKeys': applyRollbackKeys, 'officeId': this.$store.getters.currentOfficeId }
      // redPunchApplyRollbackOrSearch(obj).then(res => {
      //   if (res.data) {
      //     this.toQueryInvoiceList()
      //     this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
      //   } else {
      //     this.$message.error(this.$t('CargoMsg.Cargo_OperatedFailed'))
      //   }
      // }).finally(() => {
      //   loading.close()
      // })
    },
    // 全电认证二维码弹窗
    async authRecognition() {
      if (!this.properties.FeiByAuth) { // 全电开票是否开启验证
        return true
      }
      if (!this.isFei) return true
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return false
      }
      // 全电实人认证校验
      let faceAuth = false
      for (const invoice of selections) {
        if (faceAuth) break
        faceAuth = (invoice.invoiceType === InvoiceConstant.INVOICE_TYPE_VAT_FEI.code || invoice.invoiceType === InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code)
      }
      if (!faceAuth) return true
      const loading = getLoading4Cxt()
      const obj = { 'officeId': this.$store.getters.currentOfficeId }
      await authRecognition(obj).then(res => {
        const result = res.data
        this.ewmDialog.time = 15
        if (result.success && result.ewm) { // 二维码 弹框
          this.ewmDialog.ewm = result.ewm
          this.ewmDialog.visible = true
          this.ewmDialog.curTime = setInterval(() => {
            if (this.ewmDialog.time === 0) {
              clearInterval(this.ewmDialog.curTime)
            } else {
              this.ewmDialog.time--
            }
          }, 1000)
          return false
        } else if (!result.success && result.msg) {
          this.$message.error(result.msg)
          return false
        }
        return true
      }).finally(() => {
        loading.close()
      })
    },
    // 实人认证
    personAuth() {
      if (this.properties.QdWarning) {
        this.$confirm(this.$t('Invoice.QdWarningTip'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          showCancelButton: false,
          closeOnClickModal: false,
          type: 'warning'
        })
        return
      }
      const loading = getLoading4Cxt()
      const obj = { 'officeId': this.$store.getters.currentOfficeId }
      authRecognition(obj).then(res => {
        const result = res.data
        this.ewmDialog.time = 15
        if (result.success && result.ewm) { // 二维码 弹框
          this.ewmDialog.ewm = result.ewm
          this.ewmDialog.visible = true
          this.ewmDialog.curTime = setInterval(() => {
            if (this.ewmDialog.time === 0) {
              clearInterval(this.ewmDialog.curTime)
            } else {
              this.ewmDialog.time--
            }
          }, 1000)
        } else if (!result.success && result.msg) {
          this.$message.error(result.msg)
          return false
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 发送共享中心
    sendSharingCenter() {
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return
      }
      const keys = []
      for (const invoice of selections) {
        if (!invoice.isAr) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectInvoiceAR'))
          return
        }
        if ([3, 4, 5].includes(invoice.sendState)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectNoPushData'))
          return
        }
        keys.push(invoice.uuid)
      }
      const loading = getLoading4Cxt(this)
      const filterJson = {}
      filterJson.uuidList = keys
      filterJson.branchId = this.$store.getters.currentOfficeId
      checkPushFunc(filterJson).then(res => {
        if (res.data === 'ok') {
          this.doSendSharingCenter(keys)
        } else {
          this.$message.warning(ColumnUtils.showTypeLabelFunc(res.data, SystemConstants.ERROR_MAPPING_TYPE))
        }
      }).finally(() => {
        loading.close()
      })
    },
    doSendSharingCenter(keys) {
      const filterJson = {}
      filterJson.uuidList = keys
      filterJson.type = 'financialAR' // 财务应收单
      filterJson.branchId = this.$store.getters.currentOfficeId
      const loading = getLoading4Cxt(this)
      pushPreliminaryFunc(filterJson).then(res => {
        if (res.data) {
          const data = res.data
          if (data.errorCode) {
            this.$message.warning(ColumnUtils.showTypeLabelFunc(data.errorCode, SystemConstants.ERROR_MAPPING_TYPE))
          } else if (data.syncTip) {
            this.$message.success(ColumnUtils.showTypeLabelFunc(data.syncTip, SystemConstants.ASYNC_MAPPING_TYPE))
          } else {
            this.$message.success(this.$t('CargoMsg.Cargo_SendingResult', [data.successCount, data.failCount]))
            this.toQueryInvoiceList()
          }
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 获取发送结果
    querySendResult() {
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return
      }
      const keys = []
      for (const invoice of selections) {
        if (!invoice.isAr) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectInvoiceAR'))
          return
        }
        if ([-1, 1, 2].includes(invoice.sendState)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectInvoiceAR2'))
          return
        }
        keys.push(invoice.feedbackUniqueId)
      }
      const filterJson = {}
      filterJson.uuidList = keys
      filterJson.type = 'financialAR' // 财务应收单
      filterJson.branchId = this.$store.getters.currentOfficeId
      const loading = getLoading4Cxt(this)
      queryOrderLogFunc(filterJson).then(res => {
        if (res.data) {
          this.$message.success(this.$t('CargoMsg.Cargo_doTip'))
          this.toQueryInvoiceList()
        }
      }).finally(() => {
        loading.close()
      })
    },
    onView(value) {
      this.pushLogDialog.visible = true
      this.pushLogDialog.uuid = value
    },
    /**
     * 获取发票号-全电公共
     */
    async getInvoiceNoQd() {
      const allowTaxOperation = await BSWarningUtil.checkTaxExpire()
      if (!allowTaxOperation) {
        return
      }
      if (this.properties.QdWarning) {
        this.$confirm(this.$t('Invoice.QdWarningTip'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          showCancelButton: false,
          closeOnClickModal: false,
          type: 'warning'
        })
        return
      }
      const keys = []
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return
      }
      for (const invoice of selections) {
        if (!invoice.exportToGoldenTax || (!this.isAisinoEi && !invoice.returnTaxCode)) {
          this.$message.warning(this.$t('Invoice.NotInvoice'))
          return
        }
        // 过滤有发票号或者非全电
        if (invoice.invoiceNo || (invoice.invoiceType !== InvoiceConstant.INVOICE_TYPE_VAT_FEI.code && invoice.invoiceType !== InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code)) {
          continue
        }
        keys.push(invoice.uuid)
      }
      if (keys.length === 0) {
        this.$message.warning(this.$t('Invoice.SelectRightInvoice'))
        return
      }
      const loading = getLoading4Cxt(this)
      const obj = { 'keys': keys, 'loadSubDetail': false }
      obj.officeId = this.$store.getters.currentOfficeId
      obj.interfaceName = this.properties.interfaceNameEI
      obj.location = this.location
      getInvoiceNoQd(obj).then(res => {
        if (res.data && res.data.length > 0) {
          let success = false
          let fail = false
          for (const item of selections) {
            for (const invoice of res.data) {
              if (item.uuid === invoice.uuid) {
                // 发票号
                item.invoiceNo = invoice.invoiceNo
                item.invoiceDate = invoice.invoiceDate
                item.webPdfFile = invoice.webPdfFile
                item.isPrinted = invoice.printed
                item.returnTaxCode = invoice.returnTaxCode
                item.returnTaxMsg = invoice.returnTaxMsg
                item.exportToGoldenTax = invoice.exportToGoldenTax
                item.webOfdUrl = invoice.webOfdUrl
                item.webXmlUrl = invoice.webXmlUrl
              }
            }
            if (StrUtils.isEmpty(item.invoiceNo)) fail = true
            if (!StrUtils.isEmpty(item.invoiceNo)) success = true
          }
          if (success && !fail) {
            this.$message.success(this.$t('Invoice.GetInvoiceNoSuccessBwjsy'))
          } else if (!success && fail) {
            this.$message.error(this.$t('Invoice.GetInvoiceNoFail'))
          } else if (success && fail) {
            this.$message.warning(this.$t('Invoice.GetInvoiceNoFailPart'))
          }
          this.refreshGrid()
        } else {
          this.$message.error(this.$t('Invoice.GetInvoiceNoFail'))
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 下载电子发票Ofd
    btnDownloadOfdHandler(invoice) {
      if (StrUtils.isEmpty(invoice.invoiceNo)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoElectronicInvoiceNoToCreate'))
        return
      }
      if (StrUtils.isEmpty(invoice.webOfdUrl)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PCITIHBI'))
        return
      }
      window.open(invoice.webOfdUrl)
      this.addDownloadLogHandler(invoice, 'OFD', invoice.webOfdUrl)
    },
    // 下载电子发票Xml
    btnDownloadXmlHandler(invoice) {
      if (StrUtils.isEmpty(invoice.invoiceNo)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoElectronicInvoiceNoToCreate'))
        return
      }
      if (StrUtils.isEmpty(invoice.webXmlUrl)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PCITIHBI'))
        return
      }
      window.open(invoice.webXmlUrl)
      this.addDownloadLogHandler(invoice, 'XML', invoice.webXmlUrl)
    },
    // 点击下载次数
    clickDownloadSize(invoice) {
      if (invoice.downloadSize > 0) {
        this.downloadLogWindow.invoiceKey = invoice.uuid
        this.downloadLogWindow.visible = true
      }
    },
    // 杰贝越南税控-查询发票号/下载发票
    getInvoiceNoByEasyInvoice(flag = '') {
      const keys = []
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectInvoice'))
        return
      }
      for (const invoice of selections) {
        if (!invoice.exportToGoldenTax) {
          this.$message.warning(this.$t('Invoice.NotInvoice'))
          return
        }
        // if (invoice.invoiceNo) {
        //   return
        // }
        keys.push(invoice.uuid)
      }
      if (keys.length === 0) return
      const office = this.$store.getters.currentOffice
      if (StrUtils.isEmpty(office.userNameEi) || StrUtils.isEmpty(office.taxPayerIdEi) ||
        StrUtils.isEmpty(office.authorizationCodeEi) || StrUtils.isEmpty(office.invoiceServiceEi)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CBEIPCTSINACSRANMPC'))
        return
      }
      const loading = getLoading4Cxt(this)
      const obj = { 'keys': keys, 'loadSubDetail': false }
      obj.officeId = this.$store.getters.currentOfficeId
      obj.userName = office.userNameEi // 平台编码
      obj.passWord = office.passWordEi // 密码
      obj.taxpayerId = office.taxPayerIdEi // 纳税人识别号
      obj.authorizationCode = office.authorizationCodeEi // 纳税人授权码
      obj.wsdlLocation = office.invoiceServiceEi // 电子发票服务请求地址
      obj.location = this.location
      const callFunction = flag === 'getInvoicePdf' ? getInvoicePdfByEasyInvoice : (flag === 'checkInvoiceState' ? getInvoiceStatusByEasyInvoice : getInvoiceNoByEasyInvoice)
      callFunction(obj).then(res => {
        // 这里返回的都是成功的数据
        if (res.data && res.data.length > 0) {
          for (const item of selections) {
            for (const invoice of res.data) {
              if (item.uuid === invoice.uuid) {
                // 发票号
                item.invoiceNo = invoice.invoiceNo
                item.invoiceDate = invoice.invoiceDate
                item.webPdfFile = invoice.webPdfFile
                item.isPrinted = invoice.printed
                item.invoiceStatusVietnam = invoice.invoiceStatusVietnam
              }
            }
          }
          this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
          this.refreshGrid()
        } else {
          this.$message.error(this.$t('CargoMsg.Cargo_OperationFailed'))
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 同步云平台
    syncCloudPlatform() {
      if (this.hmToFinanceApi) {
        this.syncCloudPlatformHM()
        return
      }
      if (this.jydToFinanceApi) {
        this.syncCloudPlatformU8()
      }
      if (this.qlToFinanceApi) {
        this.syncCloudPlatformQL()
      }
    },
    // 上海虹迈
    syncCloudPlatformHM() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseCheckInvoice'))
        return
      }
      const invoiceKeys = []
      for (const row of rows) {
        if (!row.invoiceNo) {
          this.$message.warning(this.$t('Clearing.InvoiceNoEmptyNotPush'))
          return
        }
        if (row.syncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
          this.$message.warning(this.$t('Clearing.InvoicePushNotAgain'))
          return
        }
        if (!row.isAr && !row.actualReceiptDate) {
          this.$message.warning(this.$t('Clearing.PayableInvoiceActualReceiptDateEmpty'))
          return
        }
        if (row.currency !== 'RMB') {
          this.$message.warning(this.$t('Clearing.PushYongYouInvoiceNeedRMB'))
          return
        }
        invoiceKeys.push(row.uuid)
      }
      const loading = getLoading4Cxt(this)
      doHmSyncInvoiceChargeToYongYou(invoiceKeys).then(res => {
        loading.close()
        this.$message.success(this.$t('Message.SynchronizationSucceeded'))
        this.toQueryInvoiceList()
      }).catch(() => {
        loading.close()
      })
    },

    syncCloudPlatformQL() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseCheckInvoice'))
        return
      }
      const invoiceKeys = []
      for (const row of rows) {
        invoiceKeys.push(row.uuid)
      }
      const loading = getLoading4Cxt(this)
      doSyncInvoiceQL(invoiceKeys).then(res => {
        loading.close()
        this.$message.success(this.$t('Message.SynchronizationSucceeded'))
      }).catch((e) => {
        console.log(e)
        // loading.close()
      }).finally(() => {
        loading.close()
        this.toQueryInvoiceList()
      })
    },

    // 集翊达用友U8CLOUD
    async syncCloudPlatformU8() {
      if (!this.syncCloudPlatAble) {
        return
      }
      this.syncCloudPlatAble = false
      const loading = getLoading4Cxt(this)
      try {
        if (!await this.checkInvoiceToYYU8()) {
          loading.close()
          this.syncCloudPlatAble = true
          return
        }
      } catch (e) {
        loading.close()
        this.syncCloudPlatAble = true
        return
      }
      const rows = getGridSelected(this.gridOptions)
      const invoiceKeys = Array.from(rows, p => p.uuid)
      syncInvoiceToYYU8({ keys: invoiceKeys, branchId: this.$store.getters.currentOfficeId }).then(res => {
        loading.close()
        const result = res.data
        if (result) {
          const successSize = result.successList ? result.successList.length : 0
          const failSize = result.failList ? result.failList.length : 0
          this.$message.success(this.$t('SystemDocking.Success0entriesFailure0entries', [successSize, failSize]))
          this.toQueryInvoiceList()
        }
      }).catch(() => {
        loading.close()
      }).finally(() => {
        this.syncCloudPlatAble = true
      })
    },
    // 调用接口前校验
    async checkInvoiceToYYU8() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseCheckInvoice'))
        return false
      }
      const invoiceKeys = []
      for (const row of rows) {
        if (!row.invoiceNo) {
          this.$message.warning(this.$t('Clearing.InvoiceNoEmptyNotPush'))
          return false
        }
        if (row.syncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
          this.$message.warning(this.$t('Clearing.InvoicePushNotAgain'))
          return false
        }
        // CARGO-43929 去除 发票币种必须是RMB的校验
        // if (row.currency !== 'RMB') {
        //   this.$message.warning(this.$t('Clearing.OnlySupportRmb'))
        //   return false
        // }
        // 红冲发票不可推送
        if (row.isRevoked && row.invoiceState === Number(InvoiceConstant.OFFSET_RED_PUNCH.code)) { // 0未红冲 1被红冲 2红冲
          this.$message.warning(this.$t('Clearing.OffsetRedPunchTipU8C'))
          return
        }
        // if (row.chargeCurrency1 && row.chargeCurrency2 && row.chargeCurrency1 !== row.chargeCurrency2) {
        //   this.$message.warning(this.$t('Clearing.NotSupportMultiCurrency'))
        //   return false
        // }
        invoiceKeys.push(row.uuid)
      }
      const result = await checkInvoiceToYYU8(invoiceKeys).then(res => res.data)
      if (result) {
        if (result.msgType === 1) { // 勾选的发票是国外费用。
          this.$message.warning(this.$t('Clearing.OnlySupportInternal'))
          return false
        }
        if (result.msgType === 2) { // 对应发票抬头没有对应用友的“凭证系统客商编码”
          this.$message.warning(this.$t('Clearing.InvoiceTitleNotSync', [result.msg]))
          return false
        }
        // CARGO-43977 混合币种发票处理
        // if (result.msgType === 3) { // 存在混合发票币种，无法推送用友。请调整数据
        //   this.$message.warning(this.$t('Clearing.NotSupportMultiCurrency'))
        //   return false
        // }
      }
      return true
    },
    // 导出Accpac发票数据
    exportPillInvoiceHandler() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const invoiceUuids = []
      for (const item of rows) {
        if (StrUtils.isEmpty(item.invoiceNo)) {
          this.$message.warning(this.$t('PillReport.SelectDataWithInvoiceNumber'))
          return
        }
        invoiceUuids.push(item.uuid)
      }

      this.loading = getLoading()
      exportInvoice({ 'requires': invoiceUuids }).then(res => {
        if (res.ok) {
          const h = this.$createElement
          this.$msgbox({
            title: this.$t('common.tips.prompt'),
            message: h('p', null, [
              h('p', { style: 'font-size: 18px;padding-bottom:5px' }, this.$t('PillReport.ExportingData')),
              h('p', { style: 'color: red' }, this.$t('CargoMsg.Cargo_ImportingDataSuccess'))
            ]),
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'success'
          })
        } else {
          this.$confirm(res.message, this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            canCloseModule: true,
            type: 'warning'
          })
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    previewVoucherHandler() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const invoiceUuids = []
      for (const item of rows) {
        if (StrUtils.isEmpty(item.invoiceNo)) {
          this.$message.warning(this.$t('PillReport.SelectDataWithInvoiceNumber'))
          return
        }
        invoiceUuids.push(item.uuid)
      }
      if (invoiceUuids.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_HasOneOnly'))
        return
      }
      this.loading = getLoading()
      queryInvoiceAccountingDocument(invoiceUuids).then(res => {
        const voucherList = res.data.voucherList || []
        const accountSetList = res.data.accountSetList || []
        if (voucherList && voucherList.length > 0) {
          this.accountingEntryWindow.visible = true
          this.accountingEntryWindow.multiAccountSet = true
          this.accountingEntryWindow.rowData = voucherList
          this.accountingEntryWindow.accountSet = accountSetList.length > 0 ? accountSetList[0] : null
          this.accountingEntryWindow.index = 0
          if (this.accountingEntryWindow.accountSet) {
            const prefixList = []
            for (const accountingDocumentType of this.accountingEntryWindow.accountSet.accountingDocumentType) {
              if (prefixList.length === 0) {
                prefixList.push(accountingDocumentType)
              } else {
                let bExist = false
                for (const prefixData of prefixList) {
                  if (prefixData.prefix === accountingDocumentType.prefix) {
                    bExist = true
                    break
                  }
                }
                if (!bExist) prefixList.push(accountingDocumentType)
              }
            }
            this.accountingEntryWindow.prefixDataProvider = prefixList
            this.accountingEntryWindow.accountTitleDataProvider = this.accountingEntryWindow.accountSet.accountTitle || []
            this.accountingEntryWindow.mappingDepartments = this.accountingEntryWindow.accountSet.mappingDepartments || []
            this.accountingEntryWindow.mappingStaffs = this.accountingEntryWindow.accountSet.mappingStaffs || []
          }
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_InvoiceNotVoucher'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    exportVoucherHandler() {
      const rows = getGridSelected(this.gridOptions)
      VoucherUtils.exportVoucherHandler(this, rows, 'tabInvoiceQuery')
    },
    addDownloadLogHandler(invoice, fileType, fileUrl) {
      addDownloadLog({ fkUuid: invoice.uuid, fileType: fileType, fileUrl: fileUrl, type: SystemConstants.INVOICE.code }).then(res => {
        if (res && res.data) {
          for (const item of this.rowData) {
            if (item.uuid === invoice.uuid) {
              item.downloadSize = res.data
              this.refreshGrid()
              break
            }
          }
        }
      })
    },
    taxNatureLabelFunction(value) {
      if (!value) {
        return ''
      }
      const taxNatures = value.split(',')
      if (taxNatures.every(p => p === '0')) {
        return this.$t('CargoMsg.Cargo_NotTaxFree')
      } else if (taxNatures.every(p => p === '1')) {
        return this.$t('CargoMsg.Cargo_DutyFree')
      }
      return this.$t('CargoMsg.Cargo_Uncertain')
    },
    onInstructionClick(item) {
      if (item.platformInstructionRuleCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_MERGE_INVOCIE_FILE.code) {
        this.$refs.mergeInvoiceFileWindow.onShowOfUI(item, this.gridOptions.api.getSelectedRows())
      }
    }
  }
}
</script>
<style lang="scss">
  #footer-wrapper {
    align-items: center;
    .fixedBottom {
      position: fixed;
      bottom: 0;
      right: 15px;
      background: #fff;
    }
  }
  .queryInvoice {
    .el-form-item-search {
      margin-right: 15px;
      .el-form-item__label {
        padding-right: 5px;
        font-size: 14px !important;
      }
      .el-form-item__content {
        .el-radio {
          margin-right: 3px;
          .el-radio__label {
            font-size: 13px !important;
            padding-left: 2px;
          }
        }
        .el-checkbox {
          .el-checkbox__label {
            font-size: 13px !important;
            padding-left: 2px;
          }
        }
        .el-date-editor {
          //.el-input__prefix {
          //  display: none;
          //}
        }
        .el-input {
          width: 110px;
        }
        .el-input__inner {
          padding-left: 20px !important;
          padding-right: 5px !important;
          width: 110px;
        }
      }
    }
  }
</style>
